{
  "common": {
    "loading": "Lädt...",
    "authenticating": "Authentifizierung...",
    "settingUpApp": "App wird eingerichtet...",
    "preparingOffline": "Offline-Modus wird vorbereitet",
    "error": "Fehler",
    "success": "Erfolg",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "close": "Schließen",
    "back": "Zurück",
    "next": "Weiter",
    "confirm": "Bestätigen",
    "search": "Suchen",
    "offlineLoginRequired": "Du bist offline. Bitte melde dich an, wenn du wieder online bist, um diese Seite zu nutzen.",
    "offlineRequiresConnection": "Diese Funktion benötigt eine Internetverbindung",
    "filter": "Filtern",
    "export": "Exportieren",
    "import": "Importieren",
    "download": "Herunterladen",
    "upload": "Hochladen",
    "view": "Ansehen",
    "details": "Details",
    "settings": "Einstellungen",
    "logout": "Abmelden",
    "login": "Anmelden",
    "register": "Registrieren",
    "yes": "Ja",
    "no": "Nein",
    "ok": "OK",
    "name": "Name",
    "description": "Beschreibung",
    "date": "Datum",
    "time": "Zeit",
    "status": "Status",
    "actions": "Aktionen",
    "more": "Mehr",
    "optional": "(optional)",
    "saving": "Wird gespeichert...",
    "open": "Öffnen",
    "unknown": "Unbekannt",
    "unknownError": "Unbekannter Fehler",
    "roles": {
      "SUPERUSER": "Superuser",
      "ADMIN": "Administrator",
      "SITE_MANAGER": "Bauleiter",
      "CONTRACTOR": "Auftragnehmer",
      "VIEWER": "Betrachter",
      "USER": "Benutzer"
    },
    "editDefectDetails": "Mangeldetails bearbeiten",
    "editBoundingBox": "Markierung anpassen",
    "deleteDefect": "Mangel löschen",
    "confirmDeleteDefect": "Möchten Sie diesen Mangel wirklich löschen?",
    "defectDeleted": "Mangel gelöscht",
    "errorDeletingDefect": "Fehler beim Löschen",
    "addManualDefect": "Mangel hinzufügen",
    "editDefect": "Mangel bearbeiten",
    "addManualDefectDescription": "Erstellen Sie einen neuen Mangel. Sie können die Position danach anpassen.",
    "noManualDefectsYet": "Noch keine Mängel erfasst.",
    "editDefectDescription": "Bearbeiten Sie die Details des Mangels.",
    "defectType": "Mangeltyp",
    "severity": "Schweregrad",
    "trade": "Gewerk",
    "recommendation": "Empfehlung",
    "describeDefect": "Beschreiben Sie den Mangel...",
    "recommendedActions": "Empfohlene Maßnahmen...",
    "createDefect": "Mangel erstellen",
    "requiredField": "Bitte füllen Sie alle Pflichtfelder aus",
    "errorUpdatingDefect": "Fehler beim Aktualisieren des Mangels",
    "defectSuccessfullyUpdated": "Mangel erfolgreich aktualisiert",
    "errorCreatingDefect": "Fehler beim Erstellen des Mangels",
    "defectSuccessfullyCreated": "Mangel erfolgreich erstellt",
    "defectQueuedOffline": "Mangel gespeichert — wird bei Verbindung synchronisiert",
    "pending": "Ausstehend",
    "errorSavingDefect": "Fehler beim Speichern des Mangels",
    "inspectionNotEditable": "Begehung ist abgeschlossen und kann nicht mehr bearbeitet werden",
    "creating": "Erstellen...",
    "updating": "Speichern...",
    "pullToRefresh": "Ziehen zum Aktualisieren",
    "releaseToRefresh": "Loslassen zum Aktualisieren"
  },
  "nav": {
    "home": "Startseite",
    "dashboard": "Statistiken",
    "detect": "Foto / KI Analyse",
    "history": "Historie",
    "projects": "Projekte",
    "knowledgeBase": "Wissensdatenbank",
    "contractors": "Auftragnehmer",
    "tickets": "Mangelanzeige",
    "emailTemplates": "E-Mail Vorlagen",
    "billing": "Abrechnung",
    "admin": "Admin",
    "aiTraining": "KI-Training",
    "systemSettings": "Systemeinstellungen",
    "profile": "Profil",
    "details": "Details",
    "inspections": "Begehungen",
    "new": "Neu",
    "floorplan": "Grundriss",
    "users": "Benutzer",
    "manual": "Tipps & Hilfe",
    "board": "Aufgaben"
  },
  "knowledgeBase": {
    "title": "Wissensdatenbank",
    "subtitle": "Gelöste Mängel aus vergangenen Projekten - Lernen Sie aus bewährten Lösungen",
    "searchPlaceholder": "Mangeltyp suchen...",
    "stats": {
      "defectTypes": "Mangeltypen",
      "solvedCases": "Gelöste Fälle",
      "searchResults": "Suchergebnisse"
    },
    "noSolutionsFound": "Keine Lösungen gefunden",
    "tryDifferentSearch": "Versuchen Sie eine andere Suche",
    "noSolutionsYet": "Es sind noch keine gelösten Mängel verfügbar",
    "solvedCases": "gelöste Fälle",
    "viewAllSolutions": "Alle Lösungen anzeigen",
    "before": "Vorher",
    "after": "Nachher",
    "noPreviewAvailable": "Keine Vorschau verfügbar",
    "project": "Projekt",
    "solved": "Gelöst",
    "solution": "Lösung",
    "contractorNotes": "Notizen vom Auftragnehmer",
    "viewTicket": "Ticket anzeigen",
    "severity": "Schweregrad",
    "trade": "Gewerk",
    "suggestions": "Ähnliche Lösungen",
    "basedOnPreviousSolutions": "Basierend auf früheren Lösungen",
    "backToOverview": "Zurück zur Übersicht",
    "solvedCase": "gelöster Fall",
    "solvedCasesCount": "gelöste Fälle",
    "noSolutionsAvailable": "Keine Lösungen verfügbar",
    "noSolutionsForType": "Für diesen Mangeltyp wurden noch keine gelösten Fälle dokumentiert.",
    "solutionNumber": "Lösung #",
    "high": "Hoch",
    "medium": "Mittel",
    "low": "Niedrig",
    "beforeAfter": "Vorher / Nachher",
    "problemDescription": "Problembeschreibung",
    "solutionNotes": "Notizen zur Lösung",
    "suggestionsTitle": "Lösungsvorschläge",
    "suggestionsFromKnowledgeBase": "Lösungsvorschläge aus Wissensdatenbank",
    "howWasSolved": "Wie wurde",
    "inThePastSolved": "in der Vergangenheit gelöst?",
    "case": "Fall",
    "cases": "Fälle",
    "showAll": "Alle anzeigen",
    "morePhotos": "weitere",
    "problem": "Problem",
    "solutionText": "Lösung",
    "moreSolutions": "Mehr Lösungen"
  },
  "dashboard": {
    "title": "Statistiken",
    "welcome": "Willkommen zurück",
    "totalAnalyses": "Analysen gesamt",
    "defectsFound": "Mängel gefunden",
    "activeProjects": "Aktive Projekte",
    "pendingTickets": "Offene Tickets",
    "recentAnalyses": "Letzte Analysen",
    "quickActions": "Schnellaktionen",
    "startNewAnalysis": "Neue Analyse starten",
    "viewAllProjects": "Alle Projekte ansehen",
    "stats": "Statistiken",
    "newAnalysis": "Neue Analyse",
    "analysesMonth": "Analysen (Monat)",
    "remaining": "verbleibend",
    "critical": "kritisch",
    "manageProjects": "Projekte verwalten",
    "ticketsSent": "Mängelanzeigen",
    "resolved": "gelöst",
    "showAll": "Alle anzeigen",
    "performAnalysisNow": "Analyse jetzt durchführen!",
    "noAnalysesYet": "Noch keine Analysen",
    "startFirstAnalysis": "Starten Sie Ihre erste KI-Analyse",
    "startFirstAnalysisButton": "Erste Analyse starten",
    "usageOverview": "Nutzungsübersicht",
    "monthlyUsage": "Monatlicher Verbrauch",
    "daysRemaining": "Tage übrig",
    "recentTickets": "Aktuelle Tickets",
    "all": "Alle",
    "noTickets": "Keine Tickets vorhanden",
    "statusOpen": "Offen",
    "statusInReview": "In Prüfung",
    "statusCompleted": "Erledigt",
    "adminOverview": "Admin Übersicht",
    "users": "Benutzer",
    "orgUsage": "Org. Nutzung",
    "avgPerUser": "⌀ pro Benutzer",
    "activeUsers": "Aktive Benutzer",
    "adminDashboard": "Admin Dashboard",
    "errorLoading": "Fehler beim Laden",
    "dashboardDataError": "Dashboard-Daten konnten nicht geladen werden.",
    "retryButton": "Erneut versuchen",
    "user": "Benutzer"
  },
  "detect": {
    "title": "Mangelerfassung",
    "subtitle": "Foto aufnehmen oder hochladen zur AI-Analyse",
    "takePhoto": "Foto aufnehmen",
    "uploadPhoto": "Foto hochladen",
    "analyzing": "Analysiere...",
    "analyzingImage": "Analysiere Bild...",
    "aiModelsWorking": "KI-Modelle arbeiten",
    "selectProject": "Projekt auswählen",
    "location": "Standort",
    "details": "Details",
    "startAnalysis": "Analyse starten",
    "reanalyze": "Erneut analysieren",
    "results": "Ergebnisse",
    "defectsDetected": "{count} Mängel erkannt",
    "noDefectsFound": "Keine Mängel gefunden",
    "confidence": "Konfidenz",
    "severity": "Schweregrad",
    "saveAnalysis": "Analyse speichern",
    "retake": "Erneut aufnehmen",
    "createFirstProject": "Erstes Projekt erstellen",
    "createProjectDescription": "Um mit der Mängelerkennung zu beginnen, erstellen Sie zunächst ein Projekt. Alle Analysen werden diesem Projekt zugeordnet.",
    "projectNameLabel": "Projektname *",
    "projectNamePlaceholder": "z.B. Neubau Wohnanlage",
    "descriptionLabel": "Beschreibung (optional)",
    "descriptionPlaceholder": "Kurze Projektbeschreibung",
    "addressLabel": "Adresse (optional)",
    "addressPlaceholder": "Projektadresse",
    "goToProjects": "Zu Projekten",
    "createProject": "Projekt erstellen",
    "creating": "Erstelle...",
    "enterProjectName": "Bitte geben Sie einen Projektnamen ein",
    "projectCreatedSuccess": "Projekt erfolgreich erstellt!",
    "projectCreationError": "Fehler beim Erstellen des Projekts",
    "imageLoadedFromHistory": "Bild aus Historie geladen - bereit zur erneuten Analyse",
    "imageQueuedOffline": "Bild zur Warteschlange hinzugefügt",
    "imageQueuedOfflineDescription": "Das Bild wird hochgeladen, sobald Sie wieder online sind.",
    "queueError": "Fehler beim Hinzufügen zur Warteschlange",
    "imageUploaded": "Bild hochgeladen!",
    "readyToAnalyze": "Bereit zur Analyse",
    "uploadFailed": "Upload fehlgeschlagen",
    "unknownError": "Unbekannter Fehler",
    "cameraAccessDenied": "Kamera-Zugriff verweigert",
    "photoTaken": "Foto aufgenommen!",
    "selectImageFirst": "Bitte erst ein Bild auswählen!",
    "uploadImageFirst": "Bitte erst ein Bild hochladen!",
    "offlineRerunNotAvailable": "Offline-Modus: Erneute Analysen sind nur online verfügbar",
    "analysisQueued": "Bild zur Warteschlange hinzugefügt",
    "analysisQueuedDescription": "Wird automatisch analysiert, sobald Sie wieder online sind",
    "offlineSnagSaved": "Snag gespeichert",
    "offlineSnagSavedDescription": "{count, plural, one {# Snag in Warteschlange} other {# Snags in Warteschlange}} - wird bei Verbindung automatisch hochgeladen",
    "checkingConnection": "Verbindung wird geprüft…",
    "queuedBanner": "{count, plural, one {# Snag in Warteschlange} other {# Snags in Warteschlange}} · wird analysiert, sobald online",
    "queuedBannerDraining": "{count, plural, one {# Snag in Warteschlange} other {# Snags in Warteschlange}} · wird jetzt verarbeitet",
    "slowConnectionQueued": "Zum Upload vorgemerkt",
    "slowConnectionQueuedDescription": "Verbindung zu langsam — wird bei besserer Verbindung hochgeladen",
    "slowConnectionDetected": "Langsame Verbindung — Uploads werden in die Warteschlange gestellt",
    "existingInspectionsOnly": "Nur bestehende Begehungen verfügbar",
    "analysisFailed": "Analyse fehlgeschlagen",
    "locationSaved": "Standort gespeichert",
    "defectIdNotFound": "Defekt-ID nicht gefunden. Bitte erneut analysieren.",
    "boundingBoxUpdated": "Bounding Box aktualisiert",
    "errorSaving": "Fehler beim Speichern",
    "updateFailed": "Update fehlgeschlagen",
    "defectRemoved": "Defekt entfernt",
    "releaseToRefresh": "Loslassen zum Aktualisieren",
    "pullToRefresh": "Ziehen zum Aktualisieren",
    "loadingHistory": "Lade Historie...",
    "defectsLabel": "Mängel",
    "okLabel": "OK",
    "unclearLabel": "Unklar",
    "switchProject": "Projekt wechseln",
    "backToCamera": "Neues Foto aufnehmen",
    "uploadTab": "Upload",
    "cameraTab": "Kamera",
    "dropImageHere": "Bild hier ablegen",
    "releaseToUpload": "Loslassen zum Hochladen",
    "clickToSelect": "oder klicken zum Auswählen",
    "openCamera": "Kamera öffnen",
    "apiKeyMissing": "API-Schlüssel fehlt",
    "apiKeyMissingContactAdmin": "KI ist nicht konfiguriert. Bitte wenden Sie sich an Ihren Administrator.",
    "goToSettings": "Zu Einstellungen",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "zoomIn": "🔍 Zoom",
    "zoomOut": "🔍 Zoom aus",
    "editBoundingBox": "Bounding Box bearbeiten",
    "removeDefect": "Defekt entfernen",
    "locationPlaceholder": "Ortsangabe (optional)",
    "analysisDetailsPlaceholder": "Analyse-Details (optional) - z.B. 'Wasserleitungen prüfen'",
    "detectedDefects": "Erkannte Mängel ({count})",
    "ticket": "Ticket",
    "workSafety": "Arbeitssicherheit ({count})",
    "otherDefects": "Weitere Mängel ({count})",
    "unknownDefect": "Unbekannter Mangel",
    "type": "Typ",
    "unknown": "Unbekannt",
    "trade": "Gewerk",
    "description": "Beschreibung",
    "requestDefectFix": "Mängelbehebung anfordern",
    "addToInspection": "Zu Begehung",
    "manualCapture": "Ohne KI-Analyse",
    "manualCaptureTooltip": "Mängel ohne KI-Analyse manuell hinzufügen",
    "manualCaptureError": "Fehler beim Erstellen der manuellen Analyse",
    "debugErrorOccurred": "Debug: Error aufgetreten",
    "debugLogs": "Debug Logs",
    "console": "Console ({count})",
    "lastError": "Last Error",
    "noLogsAvailable": "Keine Logs vorhanden",
    "noErrorAvailable": "Kein Error vorhanden",
    "copyAll": "Alles Kopieren",
    "deleteAll": "Alle Löschen",
    "allLogsCopied": "Alle Logs kopiert!",
    "logsDeleted": "Logs gelöscht",
    "detectionSettings": "Erkennungseinstellungen",
    "adjustDetectionParameters": "Passe die Erkennungsparameter an",
    "maxDetections": "Max. Erkennungen",
    "defectsToDetect": "Zu erkennende Mängel",
    "missingInsulation": "Fehlende Isolierung",
    "missingLabeling": "Fehlende Beschriftung",
    "missingGrounding": "Fehlende Erdung",
    "missingEdgeProtection": "Fehlender Kantenschutz",
    "exposedWires": "Freiliegende Leitungen",
    "contamination": "Verschmutzung",
    "safetyRisk": "Sicherheitsrisiko",
    "scaffoldingDistance": "Gerüstabstand >30cm",
    "liftOnScaffolding": "Aufzug auf Gerüst",
    "otherDefectsLabel": "Sonstige Mängel",
    "close": "Schließen",
    "exportOptions": "Export Options",
    "downloadJSON": "JSON Daten herunterladen",
    "jsonDownloaded": "JSON erfolgreich heruntergeladen!",
    "downloadImageWithMarkers": "Bild mit Markierungen herunterladen",
    "imageDownloaded": "Bild erfolgreich heruntergeladen!",
    "uploadingImage": "Bild wird hochgeladen...",
    "imageUploadedShort": "Bild hochgeladen!",
    "uploadFailedShort": "Upload fehlgeschlagen",
    "offlineAnalysisQueued": "Offline: Analyse wurde zur Warteschlange hinzugefügt",
    "takePhotoTitle": "Foto aufnehmen",
    "takePhotoSubtitle": "Positionieren Sie das zu analysierende Objekt",
    "cameraDone": "Fertig",
    "projectAndLocation": "Projekt & Standort",
    "currentProject": "Aktuelles Projekt",
    "projectLabel": "Projekt",
    "noProjectSelected": "Kein Projekt ausgewählt",
    "noActiveProject": "Kein Projekt aktiv",
    "assignHintPreparing": "Bild wird vorbereitet…",
    "locationOptional": "Standort (optional)",
    "analysisDetailsLabel": "Analyse-Details (optional)",
    "analysisDetailsPlaceholderLong": "z.B. 'Wasserleitungen im Keller prüfen' oder 'Elektroinstallation kontrollieren'",
    "analysisDetailsHelper": "Zusätzlicher Kontext für die KI-Analyse",
    "analysisSettings": "Analyse-Einstellungen",
    "noDefectsToAssign": "Keine Mängel zum Zuordnen",
    "addedToInspection": "Zur Begehung hinzugefügt",
    "assignError": "Fehler beim Zuordnen",
    "zeroDefectsTitle": "Keine Mängel erkannt",
    "zeroDefectsDescription": "Die Analyse wurde erfolgreich abgeschlossen. Es wurden keine Baumängel auf diesem Bild gefunden.",
    "rerunAnalysis": "Analyse noch einmal ausführen",
    "startNewAnalysis": "Neue Analyse starten",
    "goToHistory": "Zur Historie",
    "burst": {
      "photosTaken": "{count} Fotos aufgenommen",
      "analyzeAll": "Alle analysieren",
      "analyzeAllCount": "Alle {count} analysieren",
      "retry": "Erneut versuchen",
      "saveManual": "Ohne KI-Analyse speichern",
      "viewResults": "Ergebnisse ansehen ({count} Fotos)",
      "analysesComplete": "{count} Analysen abgeschlossen",
      "analysesFailed": "{failed} von {total} Analysen fehlgeschlagen — erneut versuchen",
      "photosSaved": "{count} Fotos gespeichert",
      "photoSaveFailed": "Foto konnte nicht gespeichert werden",
      "photosAdded": "{count} Fotos hochgeladen",
      "uploading": "Lade hoch {current} / {total}",
      "uploadComplete": "{count} Fotos hochgeladen",
      "proceedQuestion": "Wie möchten Sie fortfahren?",
      "tapHint": "Zum Auswählen antippen, zum Vergrößern erneut antippen",
      "detailsForPhoto": "Angaben für Foto {n}",
      "analyzeAllAi": "Alle mit KI analysieren",
      "createRequest": "Aufforderung erstellen",
      "analyzingProgress": "Analysiere {count} Fotos…",
      "legendSelected": "ausgewählt",
      "legendError": "Fehler",
      "legendDefects": "Mängel gefunden",
      "legendClean": "keine Mängel"
    }
  },
  "history": {
    "title": "Historie",
    "description": "Ihre KI-Analysen im Überblick",
    "loadingHistory": "Historie wird geladen...",
    "loadStuckHint": "Der lokale Datenspeicher antwortet nicht. Bitte laden Sie die App neu.",
    "reloadApp": "App neu laden",
    "noAnalyses": "Keine Analysen vorhanden",
    "filterByProject": "Nach Projekt filtern",
    "filterByDate": "Nach Datum filtern",
    "showAll": "Alle anzeigen",
    "viewDetails": "Details ansehen",
    "deleteAnalysis": "Analyse löschen",
    "analysisDate": "Analysedatum",
    "project": "Projekt",
    "defectsCount": "{count} Mängel",
    "defects": "Mängel",
    "created": "Erstellt",
    "errorLoadingHistory": "Fehler beim Laden der Historie",
    "confirmDelete": "Möchten Sie diese Analyse wirklich löschen?",
    "analysisDeleted": "Analyse gelöscht",
    "errorDeleting": "Fehler beim Löschen",
    "imageUrlNotAvailable": "Bild-URL nicht verfügbar",
    "errorLoadingImage": "Fehler beim Laden des Bildes",
    "errorPreparingRerun": "Fehler beim Vorbereiten der erneuten Analyse",
    "analysisExported": "Analyse exportiert",
    "exportFailed": "Export fehlgeschlagen",
    "locationUpdated": "Standort aktualisiert",
    "errorUpdatingLocation": "Standort-Update fehlgeschlagen",
    "projectUpdated": "Projekt aktualisiert",
    "errorUpdatingProject": "Projekt-Update fehlgeschlagen",
    "searchPlaceholder": "Freitext Suche",
    "releaseToRefresh": "Loslassen zum Aktualisieren",
    "pullToRefresh": "Ziehen zum Aktualisieren",
    "analysesCount": "{count} Analysen",
    "newAnalysis": "Neue Analyse",
    "filterAllAnalyses": "Alle Analysen",
    "filterCompleted": "Abgeschlossen",
    "filterError": "Fehlgeschlagen",
    "filterAllProjects": "Alle Projekte",
    "filterNoProject": "Ohne Projekt",
    "filterDateRange": "Zeitraum",
    "filterDateReset": "Zurücksetzen",
    "filterDateApply": "Übernehmen",
    "filterAllUsers": "Alle Benutzer",
    "filterAllInspections": "Alle Begehungen",
    "filterAllBuildings": "Alle Gebäude",
    "filterAllFloors": "Alle Etagen",
    "filterAllRooms": "Alle Räume",
    "noAnalysesFound": "Keine Analysen gefunden",
    "tryOtherFilters": "Versuchen Sie andere Filtereinstellungen",
    "offlineBanner": "Offline — gespeicherte Daten werden angezeigt",
    "offlineNoData": "Keine gespeicherten Daten",
    "offlineNoDataHint": "Bitte besuchen Sie diese Seite zunächst online, damit Daten gespeichert werden.",
    "offlineNotAvailable": "Offline nicht verfügbar",
    "offlineNotAvailableHint": "Diese Analyse wurde nicht offline gespeichert. Bitte online verbinden.",
    "pendingShort": "ausstehend",
    "performFirstAnalysis": "Führen Sie Ihre erste Analyse durch, um sie hier zu sehen",
    "startNewAnalysis": "Neue Analyse starten",
    "versionsCount": "{count} Versionen",
    "unnamedAnalysis": "Unbenannte Analyse",
    "requestDefectFix": "Mängelbehebung anfordern",
    "page": "Seite",
    "of": "von",
    "entries": "Einträge",
    "bulkExport": "Exportieren",
    "bulkExportSuccess": "Export erfolgreich heruntergeladen",
    "bulkExportFailed": "Export fehlgeschlagen. Bitte versuchen Sie es erneut."
  },
  "projects": {
    "title": "Projekte",
    "createNew": "Neues Projekt",
    "editProject": "Projekt bearbeiten",
    "deleteProject": "Projekt löschen",
    "projectName": "Projektname",
    "projectDescription": "Projektbeschreibung",
    "address": "Adresse",
    "startDate": "Startdatum",
    "endDate": "Enddatum",
    "teamMembers": "Teammitglieder",
    "addMember": "Mitglied hinzufügen",
    "noProjects": "Keine Projekte vorhanden",
    "analyses": "Analysen",
    "analysis": "Analyse",
    "tickets": "Tickets",
    "active": "Aktiv",
    "completed": "Abgeschlossen",
    "description": "Verwalten Sie Ihre Bauprojekte",
    "loading": "Projekte werden geladen...",
    "count": "{count} Projekte",
    "searchPlaceholder": "Suche nach Projektname, Beschreibung oder Adresse...",
    "filterAll": "Alle Projekte",
    "filterActive": "Standard-Projekt",
    "filterInactive": "Andere Projekte",
    "noProjectsFound": "Keine Projekte gefunden",
    "noMatchingProjects": "Keine Projekte entsprechen deiner Suche",
    "createFirstProject": "Erstelle dein erstes Projekt",
    "createFirstProjectButton": "Erstes Projekt erstellen",
    "standard": "Standard",
    "defects": "Mängel",
    "created": "Erstellt",
    "setAsStandard": "Standard setzen",
    "archiveProject": "Projekt archivieren",
    "confirmArchive": "Projekt wirklich archivieren?",
    "archived": "Archiviert",
    "confirmDelete": "Projekt \"{name}\" wirklich unwiderruflich löschen? Alle Analysen, Begehungen, Mängel, Tickets, Grundrisse und Teammitglieder dieses Projekts werden dauerhaft gelöscht. Dies kann nicht rückgängig gemacht werden.",
    "page": "Seite",
    "of": "von",
    "projectNameRequired": "Projektname *",
    "projectNamePlaceholder": "z.B. Heidelberg Uniklinik",
    "descriptionLabel": "Beschreibung",
    "descriptionPlaceholder": "Optionale Projektbeschreibung",
    "addressLabel": "Adresse",
    "addressPlaceholder": "Projektadresse",
    "saving": "Speichert...",
    "creating": "Erstellt...",
    "backToProjects": "Zurück zu Projekten",
    "projectNotFound": "Projekt nicht gefunden",
    "errorLoadingDetails": "Fehler beim Laden der Projektdetails",
    "addMemberButton": "Hinzufügen",
    "team": "Team",
    "offlineCache": "Offline speichern",
    "offlineCached": "Offline gespeichert",
    "offlineCacheAdd": "Bilder dieses Projekts auf diesem Gerät offline verfügbar machen",
    "offlineCacheRemove": "Bilder dieses Projekts nicht mehr offline vorhalten",
    "offlineCacheEnabled": "Projekt wird offline gespeichert",
    "offlineCacheDisabled": "Offline-Speicherung für Projekt deaktiviert",
    "offlineNotCached": "Nur online",
    "offlineNotCachedTooltip": "Projektdetails sind auf diesem Gerät offline nicht verfügbar",
    "open": "Offen",
    "closed": "Erledigt",
    "recentAnalyses": "Neueste Analysen",
    "viewAll": "Alle anzeigen",
    "noAnalysesYet": "Noch keine Analysen vorhanden",
    "activeTickets": "Aktive Tickets",
    "noActiveTickets": "Keine aktiven Tickets vorhanden",
    "statusCompleted": "Abgeschlossen",
    "statusProcessing": "Verarbeitung",
    "statusError": "Fehler",
    "statusOpen": "Offen",
    "statusInReview": "In Prüfung",
    "dueDate": "Fällig",
    "start": "Start",
    "end": "Ende",
    "locationLabel": "Standort (Koordinaten)",
    "loadFromAddress": "Koordinaten von Adresse laden",
    "latitude": "Breitengrad",
    "longitude": "Längengrad",
    "locationLoaded": "Koordinaten geladen",
    "locationNotFound": "Keine Koordinaten für diese Adresse gefunden",
    "loadingLocation": "Koordinaten werden geladen...",
    "newButton": "Neu",
    "inspections": "Begehungen",
    "noInspectionsYet": "Noch keine Begehungen vorhanden",
    "inspectionStatusDraft": "Entwurf",
    "inspectionStatusFinalized": "Abgeschlossen",
    "inspectionStatusArchived": "Archiviert"
  },
  "contractors": {
    "title": "Auftragnehmer",
    "addNew": "Neuer Auftragnehmer",
    "companyName": "Firmenname",
    "contactPerson": "Ansprechpartner",
    "email": "E-Mail",
    "phone": "Telefon",
    "trade": "Gewerk",
    "noContractors": "Keine Auftragnehmer vorhanden",
    "count": "{count} Auftragnehmer",
    "searchPlaceholder": "Suche nach Firmenname, Ansprechpartner, E-Mail oder Telefon...",
    "filterTrade": "Gewerk filtern",
    "allTrades": "Alle Gewerke",
    "noContractorsFound": "Keine Auftragnehmer gefunden",
    "tryOtherFilters": "Versuchen Sie andere Filtereinstellungen",
    "createFirstContractor": "Erstellen Sie Ihren ersten Auftragnehmer",
    "createFirstContractorButton": "Ersten Auftragnehmer erstellen",
    "projects": "Projekte",
    "tickets": "Tickets",
    "edit": "Bearbeiten",
    "editContractor": "Auftragnehmer bearbeiten",
    "newContractor": "Neuer Auftragnehmer",
    "companyNameRequired": "Firmenname *",
    "companyNamePlaceholder": "z.B. Elektro Müller GmbH",
    "contactPersonRequired": "Ansprechpartner *",
    "contactPersonPlaceholder": "z.B. Thomas Müller",
    "emailRequired": "E-Mail *",
    "emailPlaceholder": "info@firma.de",
    "phoneLabel": "Telefon",
    "phonePlaceholder": "+49 123 456789",
    "tradeRequired": "Gewerk *",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "create": "Erstellen",
    "contractorUpdated": "Auftragnehmer aktualisiert",
    "contractorCreated": "Auftragnehmer erstellt",
    "errorSaving": "Fehler beim Speichern",
    "confirmDelete": "Auftragnehmer wirklich löschen?",
    "contractorDeleted": "Auftragnehmer gelöscht",
    "errorDeleting": "Fehler beim Löschen",
    "paginationInfo": "Seite {current} von {total} • {count} Auftragnehmer",
    "loading": "... Auftragnehmer",
    "trades": {
      "ELECTRICAL": "Elektro",
      "PLUMBING": "Sanitär",
      "HVAC": "Heizung/Lüftung",
      "DRYWALL": "Trockenbau",
      "SCAFFOLDING": "Gerüstbau",
      "GENERAL": "Allgemein"
    }
  },
  "tickets": {
    "title": "Mangelanzeigen",
    "createNew": "Neues Ticket",
    "sendTicket": "Ticket versenden",
    "ticketNumber": "Ticket-Nr.",
    "assignedTo": "Zugewiesen an",
    "dueDate": "Frist",
    "priority": "Priorität",
    "status": "Status",
    "open": "Offen",
    "inProgress": "In Bearbeitung",
    "inReview": "In Prüfung",
    "completed": "Abgeschlossen",
    "rejected": "Abgelehnt",
    "noTickets": "Keine Tickets vorhanden",
    "ticketsCount": "{count} Tickets",
    "searchPlaceholder": "Suche nach Auftragnehmer, Projekt oder Notizen...",
    "searchingPlaceholder": "Tickets durchsuchen...",
    "filterStatus": "Status filtern",
    "allStatuses": "Alle Status",
    "filterProject": "Projekt filtern",
    "allProjects": "Alle Projekte",
    "filterContractor": "Auftragnehmer filtern",
    "allContractors": "Alle Auftragnehmer",
    "noTicketsFound": "Keine Tickets gefunden",
    "tryOtherFilters": "Versuchen Sie andere Filtereinstellungen",
    "createFirstTicket": "Erstellen Sie Ihr erstes Mängelticket",
    "sent": "Versendet",
    "project": "Projekt",
    "defectsCount": "{count} Mängel",
    "notes": "Hinweise",
    "createdBy": "Erstellt von {name} am {date}",
    "send": "Senden",
    "page": "Seite",
    "of": "von",
    "entries": "Einträge",
    "newTicket": "Neues Mängelticket",
    "contractorRequired": "Auftragnehmer *",
    "selectContractor": "Auftragnehmer auswählen",
    "projectOptional": "Projekt (optional)",
    "selectProject": "Projekt auswählen",
    "noProject": "Kein Projekt",
    "deadlineRequired": "Frist *",
    "notesLabel": "Hinweise",
    "notesPlaceholder": "Zusätzliche Hinweise zur Mängelbehebung...",
    "defectsCanBeAssigned": "Mängel können nach der Erstellung aus der Analyse-Historie zugewiesen werden.",
    "create": "Erstellen",
    "contractorAndDeadlineRequired": "Auftragnehmer und Frist sind erforderlich",
    "ticketCreated": "Ticket erstellt",
    "errorCreating": "Fehler beim Erstellen",
    "statusUpdated": "Status aktualisiert",
    "errorUpdating": "Fehler beim Aktualisieren",
    "sendTicketByEmail": "Ticket per Email versenden",
    "sendToContractor": "Ticket an {contractor} senden",
    "emailTemplate": "Email-Template",
    "selectTemplate": "Template auswählen",
    "default": "(Standard)",
    "sendNow": "Jetzt senden",
    "emailSimulated": "Email simuliert (API-Key fehlt)",
    "ticketSentSuccess": "Ticket per Email versendet",
    "errorSending": "Fehler beim Versenden"
  },
  "ticketModal": {
    "title": "Mängelbehebung anfordern",
    "requestTitle": "Aufforderung erstellen",
    "requestDescriptionLabel": "Beschreibung der Aufforderung",
    "requestDescriptionPlaceholder": "Was soll der Auftragnehmer tun? Beschreiben Sie die gewünschte Leistung...",
    "selectContractor": "Auftragnehmer auswählen",
    "selectContractorPlaceholder": "Auftragnehmer wählen...",
    "createNewContractor": "Neuen Auftragnehmer anlegen",
    "companyName": "Firmenname",
    "companyNamePlaceholder": "z.B. Elektro Müller GmbH",
    "contactPerson": "Ansprechpartner",
    "contactPersonPlaceholder": "z.B. Thomas Müller",
    "email": "E-Mail",
    "emailPlaceholder": "info@firma.de",
    "phone": "Telefon",
    "phonePlaceholder": "+49 123 456789",
    "trade": "Gewerk",
    "createContractor": "Auftragnehmer erstellen",
    "errorCreating": "Fehler beim Erstellen",
    "pleaseSelectContractor": "Bitte Auftragnehmer auswählen",
    "pleaseSelectDefect": "Bitte mindestens einen Mangel auswählen",
    "whichDefectsToForward": "Welche Mängel sollen weitergeleitet werden?",
    "confidence": "Konfidenz",
    "deadlineLabel": "Frist zur Behebung",
    "deadlineDefault": "Standard: 7 Tage ab heute",
    "additionalNotes": "Zusätzliche Hinweise (optional)",
    "notesPlaceholder": "Zusätzliche Informationen für den Auftragnehmer...",
    "emailPreview": "E-Mail-Vorschau",
    "emailTo": "An",
    "emailSubject": "Betreff",
    "emailSubjectText": "Mängelbehebung erforderlich{projectName, select, other { - {projectName}} }",
    "emailGreeting": "Sehr geehrte Damen und Herren{contactPerson, select, other {, sehr geehrte/r {contactPerson}} },",
    "emailIntroduction": "im Rahmen unserer Qualitätskontrolle{projectName, select, other { am Projekt \"{projectName}\"} } wurden folgende Mängel festgestellt, die wir Sie bitten zeitnah zu beheben:",
    "location": "Standort",
    "detectedDefects": "Festgestellte Mängel",
    "imageProof": "Bildnachweis mit Markierungen",
    "markingsExplanation": "Die nummerierten Markierungen entsprechen den oben aufgeführten Mängeln.",
    "deadlineToFix": "Frist zur Behebung",
    "emailClosing1": "Bitte bestätigen Sie den Eingang dieser Nachricht und teilen Sie uns Ihren geplanten Behebungstermin mit.",
    "emailClosing2": "Für Rückfragen stehen wir Ihnen gerne zur Verfügung.",
    "emailBestRegards": "Mit freundlichen Grüßen",
    "emailYourTeam": "Ihr Projektteam",
    "sending": "Sende...",
    "sendNow": "Jetzt senden",
    "errorSending": "Fehler beim Versenden",
    "emailSimulated": "Email simuliert (API-Key fehlt)",
    "requestSuccess": "Mängelbehebung erfolgreich angefordert!",
    "requestQueued": "Aufforderung wird bei besserer Verbindung gesendet"
  },
  "defects": {
    "missing_insulation": "Fehlende Isolierung",
    "exposed_wire": "Freiliegende Kabel",
    "missing_grounding": "Fehlende Erdung",
    "missing_labeling": "Fehlende Beschriftung",
    "missing_edge_protection": "Fehlender Kantenschutz",
    "safety_hazard": "Sicherheitsrisiko",
    "debris": "Bauschutt",
    "scaffolding_distance": "Zu großer Gerüstabstand",
    "scaffolding_lift_placement": "Unsachgemäße Aufzugplatzierung",
    "fire_hazard": "Brandgefahr",
    "bitumen_point_load_damage": "Punktlastschaden auf Dachhaut",
    "cable_spacing_violation": "Kabelabstandsverstoß",
    "other": "Mangel erkannt"
  },
  "severity": {
    "low": "Niedrig",
    "medium": "Mittel",
    "high": "Hoch",
    "critical": "Kritisch"
  },
  "trades": {
    "heating": "Heizung",
    "ventilation": "Lüftung",
    "plumbing": "Sanitär",
    "drywall": "Trockenbau",
    "electrical": "Elektro",
    "hvac": "Heizung/Lüftung",
    "scaffolding": "Gerüstbau",
    "general": "Allgemein",
    "other": "Sonstiges"
  },
  "auth": {
    "login": "Anmelden",
    "logout": "Abmelden",
    "email": "E-Mail",
    "password": "Passwort",
    "forgotPassword": "Passwort vergessen?",
    "rememberMe": "Angemeldet bleiben",
    "noAccount": "Noch kein Konto?",
    "signUp": "Registrieren",
    "invalidCredentials": "Ungültige Anmeldedaten",
    "loginSuccess": "Erfolgreich angemeldet",
    "logoutSuccess": "Erfolgreich abgemeldet"
  },
  "errors": {
    "recovery": {
      "onlineTitle": "Diese Seite kann gerade nicht angezeigt werden",
      "onlineAction": "Neu laden",
      "offlineTitle": "Diese Seite ist offline nicht verfügbar",
      "offlineAction": "Zur Startseite",
      "boundaryHome": "Zur Startseite"
    },
    "generic": "Ein Fehler ist aufgetreten",
    "network": "Netzwerkfehler",
    "unauthorized": "Nicht autorisiert",
    "notFound": "Nicht gefunden",
    "serverError": "Serverfehler",
    "validationError": "Validierungsfehler",
    "required": "Dieses Feld ist erforderlich",
    "invalidEmail": "Ungültige E-Mail-Adresse",
    "passwordTooShort": "Passwort zu kurz",
    "contactSupport": "Ein Fehler ist aufgetreten. Bitte kontaktieren Sie den Support mit dieser Fehler-ID.",
    "auth": {
      "unauthorized": "Nicht autorisiert",
      "invalidCredentials": "Ungültige Anmeldedaten",
      "emailPasswordRequired": "E-Mail und Passwort sind erforderlich",
      "userProfileNotFound": "Benutzerprofil nicht gefunden - bitte kontaktieren Sie den Support",
      "profileNotFound": "Benutzerprofil nicht gefunden",
      "userCreationFailed": "Fehler beim Erstellen des Benutzers",
      "profileCreationFailed": "Fehler beim Erstellen des Benutzerprofils",
      "authenticationFailed": "Authentifizierung fehlgeschlagen",
      "superuserRequired": "Unzulässig: SUPERUSER-Rolle erforderlich",
      "adminRequired": "Unzulässig: Admin-Rolle erforderlich",
      "notProjectMember": "Unzulässig: Kein Projektmitglied",
      "notAuthorizedTicket": "Unzulässig: Nicht berechtigt, auf dieses Ticket zuzugreifen",
      "noProjectAccess": "Unzulässig: Kein Zugriff auf dieses Projekt",
      "noCompanyAccess": "Unzulässig: Kein Zugriff auf dieses Unternehmen",
      "notResourceOwner": "Unzulässig: Sie besitzen diese Ressource nicht",
      "sessionExpired": "Sitzung abgelaufen. Bitte melden Sie sich erneut an."
    },
    "validation": {
      "emailRequired": "E-Mail ist erforderlich",
      "invalidEmail": "Ungültiges E-Mail-Format. Bitte geben Sie eine gültige E-Mail-Adresse ein (z.B. name@firma.de)",
      "invalidRole": "Ungültige Rolle. Muss ADMIN oder SITE_MANAGER sein",
      "userIdRequired": "Benutzer-ID ist erforderlich",
      "projectIdRequired": "Projekt-ID ist erforderlich",
      "ticketIdRequired": "Ticket-ID ist erforderlich",
      "memberIdRequired": "Mitglieds-ID ist erforderlich",
      "analysisIdRequired": "Analyse-ID ist erforderlich",
      "contractorIdRequired": "Auftragnehmer-ID ist erforderlich",
      "deadlineRequired": "Frist ist erforderlich",
      "missingFields": "Fehlende Pflichtfelder",
      "missingTemplateFields": "Fehlende Pflichtfelder: Name, Betreff, HTML-Body",
      "validRoleRequired": "Gültige Rolle erforderlich (SITE_MANAGER, ADMIN)",
      "noValidDefects": "Keine gültigen Mängel ausgewählt",
      "userIdOrEmailRequired": "Benutzer-ID oder E-Mail ist erforderlich",
      "emailExists": "E-Mail existiert bereits",
      "photoRequired": "Mindestens ein Foto ist erforderlich"
    },
    "users": {
      "emailExists": "Benutzer mit dieser E-Mail existiert bereits",
      "creationFailed": "Fehler beim Erstellen des Benutzers",
      "profileAutoCreationFailed": "Fehler beim automatischen Erstellen des Benutzerprofils",
      "notFound": "Benutzer nicht gefunden",
      "cannotDeleteSelf": "Sie können Ihr eigenes Konto nicht löschen",
      "cannotDeleteSuperuser": "Superuser-Konten können nicht gelöscht werden",
      "noAuthId": "Benutzer hat keine Auth-ID - kann nicht gelöscht werden",
      "deleteFailed": "Fehler beim Löschen der Benutzerauthentifizierung",
      "notFoundInAuth": "Benutzer im Auth-System nicht gefunden",
      "notFoundByEmail": "Benutzer mit dieser E-Mail nicht gefunden",
      "inviteFailed": "Fehler beim Einladen des Benutzers",
      "updateFailed": "Fehler beim Aktualisieren des Benutzers"
    },
    "projects": {
      "nameRequired": "Projektname ist erforderlich",
      "notFound": "Projekt nicht gefunden",
      "creationFailed": "Fehler beim Erstellen des Projekts",
      "fetchFailed": "Fehler beim Abrufen der Projekte",
      "updateFailed": "Fehler beim Aktualisieren des Projekts",
      "deleteFailed": "Fehler beim Löschen des Projekts",
      "setActiveFailed": "Fehler beim Setzen des aktiven Projekts",
      "fetchCreatorFailed": "Fehler beim Abrufen des Projekterstellers",
      "fetchTeamFailed": "Fehler beim Abrufen der Teammitglieder",
      "userIsCreator": "Benutzer ist bereits Projektersteller",
      "userAlreadyMember": "Benutzer ist bereits Projektmitglied",
      "addUserFailed": "Fehler beim Hinzufügen des Benutzers zum Projekt",
      "addTeamMemberFailed": "Fehler beim Hinzufügen des Teammitglieds",
      "teamMemberNotFound": "Teammitglied nicht gefunden",
      "cannotRemoveCreator": "Projektersteller kann nicht entfernt werden",
      "cannotRemoveSelf": "Sie können sich nicht selbst aus dem Projekt entfernen",
      "removeTeamMemberFailed": "Fehler beim Entfernen des Teammitglieds",
      "cannotModifyCreator": "Projektersteller kann nicht geändert werden",
      "updateRoleFailed": "Fehler beim Aktualisieren der Benutzerrolle",
      "archiveFailed": "Fehler beim Archivieren des Projekts"
    },
    "tickets": {
      "fetchFailed": "Fehler beim Abrufen der Tickets",
      "notFound": "Ticket nicht gefunden",
      "creationFailed": "Fehler beim Erstellen des Tickets",
      "updateFailed": "Fehler beim Aktualisieren des Tickets",
      "sendFailed": "Fehler beim Senden des Tickets",
      "deleteFailed": "Fehler beim Löschen des Tickets",
      "notAvailableForSubmission": "Ticket ist nicht zur Einreichung verfügbar",
      "notAvailableForCompletion": "Ticket ist nicht zur Fertigstellung verfügbar"
    },
    "contractors": {
      "notFound": "Auftragnehmer nicht gefunden",
      "createFailed": "Fehler beim Erstellen des Auftragnehmers",
      "updateFailed": "Fehler beim Aktualisieren des Auftragnehmers",
      "deleteFailed": "Fehler beim Löschen des Auftragnehmers",
      "noEmail": "Auftragnehmer hat keine E-Mail-Adresse"
    },
    "analyses": {
      "notFound": "Analyse nicht gefunden",
      "creationFailed": "Fehler beim Erstellen der Analyse",
      "loadFailed": "Fehler beim Laden der Analyse",
      "saveFailed": "Fehler beim Speichern der Analyse"
    },
    "defects": {
      "fetchFailed": "Fehler beim Abrufen der Mängel",
      "noneFound": "Keine Mängel für diese Analyse gefunden"
    },
    "emailTemplates": {
      "createFailed": "Fehler beim Erstellen der Vorlage",
      "updateFailed": "Fehler beim Aktualisieren der Vorlage",
      "deleteFailed": "Fehler beim Löschen der Vorlage",
      "notFound": "Vorlage nicht gefunden",
      "cannotDeleteDefault": "Standardvorlage kann nicht gelöscht werden"
    },
    "upload": {
      "noFile": "Keine Datei bereitgestellt",
      "uploadFailed": "Upload fehlgeschlagen",
      "failed": "Fehler beim Hochladen",
      "geminiFailed": "KI-Upload fehlgeschlagen",
      "geminiNotUploaded": "Bild noch nicht zur KI hochgeladen",
      "geminiExpired": "KI-Datei abgelaufen - bitte erneut hochladen",
      "completionPhotosFailed": "Fehler beim Hochladen der Fertigstellungsfotos"
    },
    "gemini": {
      "apiKeyMissing": "API-Schlüssel fehlt",
      "apiKeyNotConfigured": "KI API-Schlüssel nicht konfiguriert",
      "apiKeyNotConfiguredInSettings": "KI API-Schlüssel nicht in Systemeinstellungen konfiguriert",
      "apiError": "KI API-Fehler: {status} - {error}",
      "unexpectedResponse": "Unerwartete API-Antwort",
      "connectionError": "Verbindungsfehler: {error}",
      "apiCallFailed": "KI API-Aufruf fehlgeschlagen: {status} - {error}",
      "tokenLimitReached": "KI API-Token-Limit erreicht - versuchen Sie, Prompt oder maximale Mängel zu reduzieren",
      "safetyBlocked": "KI API hat Antwort aus Sicherheitsgründen blockiert",
      "invalidResponseFormat": "Ungültiges Antwortformat von KI",
      "noValidResponse": "Keine gültige Antwort von KI - Details in Logs prüfen",
      "invalidJsonResponse": "KI hat ungültige JSON-Antwort zurückgegeben: {error}",
      "parseAnalysisFailed": "Fehler beim Parsen der KI-Analyse: {error}"
    },
    "storage": {
      "uploadAnalysisImageFailed": "Fehler beim Hochladen des Analysebilds: {error}",
      "uploadCompletionPhotoFailed": "Fehler beim Hochladen des Fertigstellungsfotos: {error}",
      "deleteImageFailed": "Fehler beim Löschen des Bilds: {error}",
      "deleteImagesFailed": "Fehler beim Löschen der Bilder: {error}"
    },
    "email": {
      "sendFailed": "Fehler beim Senden der E-Mail an Auftragnehmer und Ersatzempfänger",
      "noRecipient": "Keine Empfänger-E-Mail angegeben"
    },
    "rateLimit": {
      "exceeded": "Ratenlimit überschritten. Versuchen Sie es in {seconds} Sekunden erneut.",
      "pleaseWait": "Ratenlimit überschritten. Bitte warten Sie {seconds} Sekunden.",
      "emailExceeded": "Zu viele E-Mails gesendet. Bitte versuchen Sie es später erneut."
    },
    "service": {
      "temporarilyUnavailable": "Der Dienst ist vorübergehend nicht verfügbar.",
      "circuitBreakerOpen": "Circuit Breaker GEÖFFNET - AI-Service hat Probleme"
    },
    "config": {
      "geminiKeyMissing": "KI API-Schlüssel nicht konfiguriert",
      "noPrompt": "Kein Prompt in Systemeinstellungen konfiguriert"
    },
    "permissions": {
      "cannotInvite": "Unzureichende Berechtigungen zum Einladen von Benutzern",
      "adminOrManagerOnly": "Unzulässig - Nur Admin oder Site Manager",
      "adminOnly": "Unzulässig - Nur Admin",
      "cannotManageTeam": "Nur Projektersteller und Admins können das Team verwalten"
    },
    "offlineQueue": {
      "uploadFailed": "Upload fehlgeschlagen: {error}",
      "maxRetriesExceeded": "Maximale Wiederholungsversuche überschritten"
    },
    "api": {
      "saveAnalysisFailed": "Fehler beim Speichern der Analyse",
      "fetchAnalysesFailed": "Fehler beim Abrufen der Analysen",
      "loadAnalysisFailed": "Fehler beim Laden der Analyse",
      "updateAnalysisFailed": "Fehler beim Aktualisieren der Analyse",
      "deleteAnalysisFailed": "Fehler beim Löschen der Analyse"
    },
    "preferences": {
      "fetchFailed": "Fehler beim Abrufen der Einstellungen",
      "saveFailed": "Fehler beim Speichern der Einstellungen",
      "notLoaded": "Keine Einstellungen geladen"
    },
    "systemSettings": {
      "fetchFailed": "Fehler beim Abrufen der Systemeinstellungen",
      "saveFailed": "Fehler beim Speichern der Systemeinstellungen",
      "notLoaded": "Keine Systemeinstellungen geladen"
    },
    "dashboard": {
      "fetchProjectsFailed": "Fehler beim Abrufen der Projekte",
      "fetchDataFailed": "Fehler beim Abrufen der Dashboard-Daten",
      "fetchRecentAnalysesFailed": "Fehler beim Abrufen der letzten Analysen",
      "fetchUsageFailed": "Fehler beim Abrufen der Nutzungsdaten"
    },
    "notifications": {
      "browserNotSupported": "Ihr Browser unterstützt keine Push-Benachrichtigungen."
    },
    "aiPricing": {
      "errorLoading": "Fehler beim Laden der Preise",
      "errorUpdating": "Fehler beim Aktualisieren",
      "errorToggling": "Fehler beim Aktivieren/Deaktivieren"
    },
    "firebase": {
      "missingAdminConfig": "Fehlende Firebase Admin SDK-Umgebungsvariablen"
    },
    "imageHash": {
      "canvasContextFailed": "Konnte Canvas-Kontext nicht abrufen"
    },
    "templates": {
      "notFound": "Vorlage nicht gefunden",
      "cannotDeleteDefault": "Standardvorlage kann nicht gelöscht werden"
    },
    "solutions": {
      "notFound": "Lösung nicht gefunden",
      "getFailed": "Fehler beim Abrufen der Lösungen",
      "saveFailed": "Fehler beim Speichern der Lösung",
      "deleteFailed": "Fehler beim Löschen der Lösung"
    },
    "canvas": {
      "legacyPathNotSupported": "Legacy-Pfade werden nicht mehr unterstützt - API korrigieren",
      "fetchSignedImageFailed": "Fehler beim Abrufen des signierten Bilds: {status}"
    },
    "signedImage": {
      "legacyPathNotSupported": "Legacy-Pfade werden nicht mehr unterstützt - API korrigieren",
      "fetchImageFailed": "Fehler beim Abrufen des Bilds: {status}"
    },
    "image": {
      "downloadFailed": "Bild konnte nicht aus dem Speicher heruntergeladen werden",
      "legacyPathNotSupported": "Legacy-Pfade werden nicht mehr unterstützt",
      "fetchFailed": "Bild konnte nicht geladen werden (Status: {status})"
    },
    "analysis": {
      "aiFailed": "AI-Analyse fehlgeschlagen",
      "geminiFailed": "KI-Erkennung fehlgeschlagen"
    },
    "timing": {
      "notStarted": "Timing wurde nicht gestartet"
    },
    "alerts": {
      "cameraPermissionDenied": "Kamera konnte nicht geöffnet werden. Bitte überprüfen Sie die Berechtigung.",
      "exportFailed": "Export fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "linkCopied": "Link in Zwischenablage kopiert",
      "copyError": "Fehler beim Kopieren"
    }
  },
  "success": {
    "saved": "Erfolgreich gespeichert",
    "deleted": "Erfolgreich gelöscht",
    "updated": "Erfolgreich aktualisiert",
    "created": "Erfolgreich erstellt",
    "sent": "Erfolgreich gesendet",
    "users": {
      "createdWithDefaultPassword": "Benutzer erfolgreich mit Standardpasswort erstellt",
      "deleted": "Benutzer {email} erfolgreich gelöscht",
      "teamMemberAdded": "Teammitglied erfolgreich hinzugefügt",
      "teamMemberRemoved": "{name} wurde aus dem Projekt entfernt",
      "roleUpdated": "Rolle von {name} wurde auf {role} aktualisiert"
    },
    "projects": {
      "created": "Projekt erstellt",
      "updated": "Projekt aktualisiert",
      "archived": "Projekt archiviert",
      "deleted": "Projekt gelöscht",
      "activeChanged": "Standard-Projekt geändert",
      "userAdded": "{name} wurde zum Projekt hinzugefügt",
      "existingUserAdded": "{name} wurde zum Projekt hinzugefügt (bestehender Auth-Benutzer)",
      "userAddedWithFallback": "{name} wurde zum Projekt mit Standardpasswort hinzugefügt (E-Mail-Zustellung fehlgeschlagen)",
      "userInvited": "{name} wurde zum Projekt eingeladen",
      "teamMemberAdded": "Teammitglied erfolgreich hinzugefügt",
      "teamMemberRemoved": "{name} wurde aus dem Projekt entfernt",
      "roleUpdated": "Rolle von {name} wurde auf {role} aktualisiert"
    },
    "tickets": {
      "createdAndSent": "Ticket erstellt und E-Mail versendet!",
      "createdWithFallback": "Ticket erstellt. E-Mail an Auftragnehmer fehlgeschlagen, Fallback-E-Mail an {email} gesendet.",
      "photosUploaded": "Fotos erfolgreich hochgeladen. Wartet auf Überprüfung durch Site Manager.",
      "submittedForReview": "Ticket zur Überprüfung eingereicht"
    },
    "gemini": {
      "connectionSuccessful": "Verbindung erfolgreich! KI API funktioniert."
    },
    "email": {
      "sent": "E-Mail erfolgreich versendet",
      "simulated": "E-Mail simuliert (RESEND_API_KEY nicht konfiguriert)"
    },
    "defectSolutions": {
      "initialized": "Mängellösungsdatenbank initialisiert"
    },
    "systemSettings": {
      "saved": "Einstellungen gespeichert"
    },
    "preferences": {
      "saved": "Einstellungen gespeichert"
    },
    "aiPricing": {
      "priceActivated": "Preis aktiviert",
      "priceDeactivated": "Preis deaktiviert"
    },
    "notifications": {
      "enabled": "Benachrichtigungen aktiviert"
    }
  },
  "info": {
    "email": {
      "simulated": "E-Mail simuliert (RESEND_API_KEY nicht konfiguriert)"
    },
    "tickets": {
      "createdButEmailFailed": "Ticket erstellt, aber E-Mail-Versand fehlgeschlagen."
    }
  },
  "warnings": {
    "notifications": {
      "browserNotSupported": "Dieser Browser unterstützt keine Benachrichtigungen",
      "pushNotSupported": "Push-Benachrichtigungen nicht unterstützt",
      "pushManagerNotAvailable": "Push-Manager nicht verfügbar"
    },
    "email": {
      "notConfigured": "E-Mail nicht konfiguriert - Benachrichtigung wird übersprungen"
    },
    "timing": {
      "notStarted": "Timing wurde nicht gestartet"
    }
  },
  "notifications": {
    "new": "Neue Benachrichtigung",
    "defectQueued": {
      "title": "ZeroSnag - Analyse in Warteschlange",
      "body": "Ihre Mängelerkennung wurde zur Verarbeitung hinzugefügt"
    },
    "defectProcessed": {
      "title": "ZeroSnag - Analyse abgeschlossen",
      "defectsFound": "{count} Mängel erkannt",
      "noDefects": "Keine Mängel gefunden - Alles in Ordnung!",
      "trades": "Gewerke: {trades}"
    },
    "offlineQueue": {
      "title": "ZeroSnag - Offline-Warteschlange verarbeitet",
      "successWithFailures": "{successCount} erfolgreich, {failedCount} fehlgeschlagen",
      "allSuccess": "{successCount} Analysen erfolgreich verarbeitet"
    },
    "error": {
      "notSupported": "Push-Benachrichtigungen werden nicht unterstützt",
      "denied": "Benachrichtigungen wurden abgelehnt",
      "activationFailed": "Fehler beim Aktivieren der Benachrichtigungen",
      "permissionDenied": "Berechtigung verweigert - Aktivieren Sie sie in Ihren Browser-Einstellungen"
    },
    "clickToEnable": "Klicken Sie auf den Schalter, um Benachrichtigungen zu aktivieren",
    "disableInstructions": "Um Benachrichtigungen zu deaktivieren, gehen Sie bitte in Ihre Browser-Einstellungen.",
    "description": "Erhalten Sie Benachrichtigungen über wichtige Updates, neue Mängel und Projektänderungen."
  },
  "historyDetail": {
    "title": "Analyse Details",
    "backToHistory": "Zurück zur Historie",
    "backToInspection": "Zurück zur Begehung",
    "backToImage": "Zum Bild",
    "addToInspection": "Zu Begehung",
    "analysisNotFound": "Analyse nicht gefunden",
    "analysisNotFoundDescription": "Die angeforderte Analyse konnte nicht gefunden werden.",
    "errorLoadingAnalysis": "Fehler beim Laden der Analyse",
    "statusPending": "Ausstehend",
    "statusDefectsFound": "{count} Mängel gefunden",
    "statusNoDefects": "Keine Mängel",
    "manualAnalysis": "Manuell",
    "analysisFailed": "Analyse fehlgeschlagen — erneut versuchen",
    "analysisFailedWithReason": "Analyse fehlgeschlagen — {reason}",
    "failureReason": {
      "apiKeyMissing": "KI ist nicht konfiguriert",
      "imageUnavailable": "Bild konnte nicht geladen werden",
      "invalidImage": "Bild beschädigt oder nicht lesbar",
      "uploadFailed": "Upload fehlgeschlagen",
      "analyzeFailed": "Analyse konnte nicht abgeschlossen werden",
      "rateLimited": "KI ist ausgelastet, bitte später erneut versuchen",
      "tokenLimit": "Analyse zu umfangreich",
      "safetyBlocked": "KI hat die Antwort blockiert",
      "timeout": "Zeitüberschreitung",
      "unknown": "unbekannter Fehler"
    },
    "analysisFailedRetry": "Erneut versuchen",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "zoomIn": "🔍 Zoom",
    "zoomOut": "🔍 Zoom aus",
    "imageNotAvailable": "Bild nicht verfügbar",
    "detectedDefects": "Erkannte Mängel ({count})",
    "workSafety": "Arbeitssicherheit ({count})",
    "otherDefects": "Weitere Mängel ({count})",
    "type": "Typ:",
    "confidence": "Konfidenz:",
    "severity": "Schweregrad:",
    "trade": "Gewerk:",
    "description": "Beschreibung:",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "editDefectDetails": "Mangeldetails bearbeiten",
    "editBoundingBox": "Markierung anpassen",
    "deleteDefect": "Mangel löschen",
    "confirmDelete": "Möchten Sie diesen Mangel wirklich löschen?",
    "defectDeleted": "Mangel gelöscht",
    "errorDeleting": "Fehler beim Löschen",
    "analysisInfo": "Analyse-Informationen",
    "id": "ID:",
    "created": "Erstellt:",
    "status": "Status:",
    "statusCompleted": "Abgeschlossen",
    "statusDefectsFoundShort": "Mängel gefunden",
    "analysisTime": "Analysezeit:",
    "project": "Projekt:",
    "location": "Standort:",
    "locationPlaceholder": "Ortsangabe (optional)",
    "locationSaved": "Standort gespeichert",
    "errorSavingLocation": "Fehler beim Speichern des Standorts",
    "noDefectsTitle": "Keine Mängel gefunden",
    "noDefectsDescription": "Die KI-Analyse hat keine Mängel in diesem Bild erkannt.",
    "pendingAnalysisTitle": "Analyse ausstehend",
    "pendingAnalysisDescription": "Diese Analyse wurde noch nicht durchgeführt.",
    "analyzeNow": "Jetzt analysieren",
    "reanalyze": "Erneut analysieren",
    "imageDataNotAvailable": "Bilddaten nicht verfügbar",
    "createdTickets": "Erstellte Tickets",
    "createdTicketsCount": "Erstellte Tickets ({count})",
    "createTicket": "Ticket erstellen",
    "defectNotification": "Mängelmeldung",
    "statusOpen": "Offen",
    "statusInReview": "In Prüfung",
    "statusCompletedShort": "Erledigt",
    "unknown": "Unbekannt",
    "noDeadline": "Kein Termin",
    "defectsCount": "{count} Mängel",
    "noTicketsYet": "Noch keine Tickets für diese Analyse erstellt",
    "noDefectsNoTickets": "Keine Mängel gefunden - keine Tickets erforderlich",
    "createFirstTicket": "Erstes Ticket erstellen",
    "defectIdNotFound": "Defekt-ID nicht gefunden.",
    "updateFailed": "Update fehlgeschlagen",
    "boundingBoxUpdated": "Bounding Box aktualisiert",
    "errorSaving": "Fehler beim Speichern",
    "prevAnalysis": "Vorheriges",
    "nextAnalysis": "Nächstes",
    "toCamera": "Zur Kamera"
  },
  "solutions": {
    "missing_insulation": {
      "title": "Fehlende Isolierung",
      "description": "Rohrleitungen oder Kanäle ohne ausreichende Dämmung können zu Energieverlusten und Kondensationsproblemen führen.",
      "solution1": {
        "caption": "Mineralwolle-Isolierung",
        "step1": "Oberfläche reinigen und trocknen",
        "step2": "Passende Isolierstärke gemäß EnEV wählen",
        "step3": "Isolierschalen oder -matten anbringen",
        "step4": "Fugen mit Klebeband abdichten",
        "step5": "Dampfsperre bei Bedarf anbringen",
        "step6": "Ummantelung zum Schutz installieren"
      },
      "solution2": {
        "caption": "Kautschuk-Isolierung",
        "step1": "Rohrdurchmesser und Temperaturbereich prüfen",
        "step2": "Kautschukschläuche der passenden Stärke wählen",
        "step3": "Längsnaht aufschneiden und um Rohr legen",
        "step4": "Mit Spezialkleber verschließen",
        "step5": "Endstücke sauber abdichten",
        "step6": "UV-Schutz bei Außenanwendung anbringen"
      },
      "normen": [
        "DIN 4108-10",
        "EnEV 2014",
        "DIN EN ISO 12241"
      ],
      "estimatedCost": {
        "min": 15,
        "max": 40,
        "unit": "€/m"
      },
      "preventionTip1": "Isolierung direkt bei Installation anbringen",
      "preventionTip2": "Regelmäßige Kontrolle auf Beschädigungen",
      "preventionTip3": "Dokumentation der Isolierstärken"
    },
    "exposed_wire": {
      "title": "Freiliegende Leitungen",
      "description": "Ungeschützte elektrische Leitungen stellen ein erhebliches Sicherheitsrisiko dar.",
      "solution1": {
        "caption": "Kabelkanal Installation",
        "step1": "Stromzufuhr unterbrechen und prüfen",
        "step2": "Passenden Kabelkanal auswählen",
        "step3": "Verlauf markieren und befestigen",
        "step4": "Kabel einlegen und ordnen",
        "step5": "Kanaldeckel schließen",
        "step6": "Beschriftung anbringen"
      },
      "solution2": {
        "caption": "Unterputz-Verlegung",
        "step1": "Stromkreis abschalten und sichern",
        "step2": "Schlitze gemäß DIN-Normen fräsen",
        "step3": "Leerrohre verlegen",
        "step4": "Kabel einziehen",
        "step5": "Schlitze verputzen",
        "step6": "Anschlüsse prüfen und dokumentieren"
      },
      "normen": [
        "DIN VDE 0100",
        "DIN 18015",
        "VDE 0298-4"
      ],
      "estimatedCost": {
        "min": 20,
        "max": 80,
        "unit": "€/m"
      },
      "preventionTip1": "Kabelführung bereits in Planungsphase berücksichtigen",
      "preventionTip2": "Ausreichend Reserven einplanen",
      "preventionTip3": "Regelmäßige Sichtprüfungen durchführen"
    },
    "missing_grounding": {
      "title": "Fehlende Erdung",
      "description": "Metallische Anlagenteile ohne Erdung können zur Gefahr bei Fehlerströmen werden.",
      "solution1": {
        "caption": "Potentialausgleich herstellen",
        "step1": "Haupterdungsschiene identifizieren",
        "step2": "Erdungsleiter (min. 6mm² Cu) verlegen",
        "step3": "Erdungsschellen an Rohrleitungen anbringen",
        "step4": "Verbindung zur Haupterdungsschiene herstellen",
        "step5": "Übergangswiderstand messen (< 0,1 Ohm)",
        "step6": "Dokumentation erstellen"
      },
      "solution2": {
        "caption": "Fundamenterder nachrüsten",
        "step1": "Erdungsbedarf nach DIN berechnen",
        "step2": "Ringerder um Gebäude verlegen",
        "step3": "Tiefe mindestens 0,5m",
        "step4": "Verbindung mit Haupterdungsschiene",
        "step5": "Erdungswiderstand messen",
        "step6": "Prüfprotokoll erstellen"
      },
      "normen": [
        "DIN VDE 0100-410",
        "DIN VDE 0100-540",
        "DIN 18014"
      ],
      "estimatedCost": {
        "min": 50,
        "max": 200,
        "unit": "€/Anschluss"
      },
      "preventionTip1": "Erdungskonzept vor Baubeginn erstellen",
      "preventionTip2": "Alle metallischen Teile in Erdung einbeziehen",
      "preventionTip3": "Jährliche Prüfung des Erdungswiderstands"
    },
    "missing_labeling": {
      "title": "Fehlende Beschriftung",
      "description": "Nicht beschriftete Leitungen und Komponenten erschweren Wartung und können zu Fehlbedienung führen.",
      "solution1": {
        "caption": "Rohrleitungskennzeichnung",
        "step1": "Fließrichtung und Medium bestimmen",
        "step2": "Farbcode nach DIN 2403 wählen",
        "step3": "Kennzeichnungsbänder oder Schilder anbringen",
        "step4": "Fließrichtungspfeile ergänzen",
        "step5": "Gefahrenhinweise bei Bedarf",
        "step6": "Dokumentation aktualisieren"
      },
      "solution2": {
        "caption": "Schaltschrank-Beschriftung",
        "step1": "Beschriftungsplan erstellen",
        "step2": "Einheitliche Bezeichnungen festlegen",
        "step3": "Klemmenbezeichnungen anbringen",
        "step4": "Schaltplanhalter montieren",
        "step5": "Aktuelle Pläne einlegen",
        "step6": "Wartungshinweise ergänzen"
      },
      "normen": [
        "DIN 2403",
        "DIN EN 60204-1",
        "ISO 14726"
      ],
      "estimatedCost": {
        "min": 5,
        "max": 20,
        "unit": "€/Kennzeichnung"
      },
      "preventionTip1": "Beschriftung sofort bei Installation",
      "preventionTip2": "Einheitliches Kennzeichnungssystem verwenden",
      "preventionTip3": "Beschriftungsplan pflegen"
    },
    "debris": {
      "title": "Verschmutzung/Bauschutt",
      "description": "Baustellenverschmutzung kann Arbeitsabläufe behindern und Sicherheitsrisiken darstellen.",
      "solution1": {
        "caption": "Grobreinigung",
        "step1": "Sicherheitsausrüstung anlegen",
        "step2": "Groben Schutt in Container entsorgen",
        "step3": "Kehren oder Saugen der Flächen",
        "step4": "Gefahrstoffe separat entsorgen",
        "step5": "Abfallentsorgung dokumentieren",
        "step6": "Besenreine Übergabe sicherstellen"
      },
      "solution2": {
        "caption": "Feinreinigung",
        "step1": "Staubschutzmaßnahmen treffen",
        "step2": "Industriestaubsauger einsetzen",
        "step3": "Oberflächen feucht wischen",
        "step4": "Lüftungsanlagen reinigen",
        "step5": "Fenster und Türen säubern",
        "step6": "Abnahmeprotokoll erstellen"
      },
      "normen": [
        "VOB/C DIN 18299",
        "KrWG",
        "GefStoffV"
      ],
      "estimatedCost": {
        "min": 2,
        "max": 10,
        "unit": "€/m²"
      },
      "preventionTip1": "Tägliche Grundreinigung einplanen",
      "preventionTip2": "Abfallcontainer bereitstellen",
      "preventionTip3": "Reinigungsplan erstellen"
    },
    "missing_edge_protection": {
      "title": "Fehlender Kantenschutz",
      "description": "Absturzkanten ohne Sicherung stellen eine erhebliche Unfallgefahr dar.",
      "solution1": {
        "caption": "Seitenschutz montieren",
        "step1": "Absturzhöhe und -bereich ermitteln",
        "step2": "Seitenschutzsystem nach DIN EN 13374 wählen",
        "step3": "Pfosten im Abstand max. 2,5m setzen",
        "step4": "Geländerholm auf 1m Höhe",
        "step5": "Mittelholm auf 0,5m Höhe",
        "step6": "Bordbrett min. 15cm hoch anbringen"
      },
      "solution2": {
        "caption": "Fangnetze installieren",
        "step1": "Netztyp nach Absturzhöhe wählen",
        "step2": "Befestigungspunkte prüfen",
        "step3": "Netze maximal 6m unter Absturzkante",
        "step4": "Überlappung min. 75cm",
        "step5": "Prüfung durch Sachkundigen",
        "step6": "Prüfplakette anbringen"
      },
      "normen": [
        "DIN EN 13374",
        "DGUV Regel 101-002",
        "ASR A2.1"
      ],
      "estimatedCost": {
        "min": 30,
        "max": 100,
        "unit": "€/lfm"
      },
      "preventionTip1": "Absturzsicherung vor Arbeitsbeginn",
      "preventionTip2": "Wöchentliche Sichtprüfung",
      "preventionTip3": "Dokumentation der Prüfungen"
    },
    "safety_hazard": {
      "title": "Allgemeine Sicherheitsrisiken",
      "description": "Verschiedene Gefahrenquellen, die die Arbeitssicherheit beeinträchtigen.",
      "solution1": {
        "caption": "Gefahrenbereich absperren",
        "step1": "Gefährdungsbeurteilung durchführen",
        "step2": "Absperrband oder Bauzaun errichten",
        "step3": "Warnschilder aufstellen",
        "step4": "Beleuchtung bei Bedarf",
        "step5": "Zugangskontrollen einrichten",
        "step6": "Dokumentation der Maßnahmen"
      },
      "solution2": {
        "caption": "Schutzmaßnahmen implementieren",
        "step1": "PSA-Pflicht festlegen",
        "step2": "Unterweisung durchführen",
        "step3": "Sicherheitsbeauftragten benennen",
        "step4": "Notfallplan erstellen",
        "step5": "Erste-Hilfe-Material bereitstellen",
        "step6": "Regelmäßige Sicherheitsbegehungen"
      },
      "normen": [
        "ArbSchG",
        "BaustellV",
        "DGUV Vorschrift 1"
      ],
      "estimatedCost": {
        "min": 100,
        "max": 500,
        "unit": "€/Maßnahme"
      },
      "preventionTip1": "Gefährdungsbeurteilung vor Arbeitsbeginn",
      "preventionTip2": "Regelmäßige Sicherheitsunterweisungen",
      "preventionTip3": "Meldekette für Gefahren etablieren"
    }
  },
  "ticketDetail": {
    "loading": "Ticket wird geladen...",
    "notFound": "Ticket nicht gefunden",
    "notFoundDescription": "Das angeforderte Ticket existiert nicht oder wurde gelöscht.",
    "backToOverview": "Zurück zur Übersicht",
    "errorLoading": "Fehler beim Laden des Tickets",
    "errorUpdatingStatus": "Status konnte nicht aktualisiert werden",
    "errorUpdatingStatusMessage": "Fehler beim Aktualisieren des Status",
    "statusUpdated": "Status erfolgreich aktualisiert",
    "created": "Erstellt",
    "sent": "Gesendet",
    "overdue": "⚠️ Überfällig",
    "zoomOut": "🔍 Zoom aus",
    "zoom": "🔍 Zoom",
    "detectedDefects": "Festgestellte Mängel",
    "recommendation": "Empfehlung",
    "changeStatus": "Status ändern",
    "statusOpen": "Offen",
    "statusInReview": "In Prüfung",
    "statusCompleted": "Erledigt",
    "confirmCompletion": "Behebung bestätigen",
    "reject": "Ablehnen",
    "deadline": "Frist",
    "oclock": "Uhr",
    "contractor": "Auftragnehmer",
    "project": "Projekt",
    "createdBy": "Erstellt von",
    "completionDocumentation": "Dokumentation der Behebung",
    "completion": "Behebung",
    "noPhotosUploaded": "Keine Fotos hochgeladen",
    "contractorNotes": "Anmerkungen vom Handwerker:",
    "waitingForContractor": "Warten auf Rückmeldung vom Handwerker",
    "shareLink": "Teilen Sie diesen Link mit dem Handwerker für die Dokumentation der Behebung",
    "scanQR": "QR-Code scannen",
    "directLink": "Direkter Link",
    "directLinkInstructions": "Klicken Sie auf den Link oder senden Sie ihn per E-Mail/WhatsApp an den Handwerker:",
    "hint": "💡 Hinweis:",
    "hintText": "Der Handwerker kann über diesen Link Fotos der Behebung hochladen und Anmerkungen hinzufügen."
  },
  "projectTeam": {
    "title": "Team",
    "description": "Verwalte Projektmitglieder und sende Einladungen",
    "searchPlaceholder": "Teammitglieder durchsuchen...",
    "inviteMember": "Mitglied einladen",
    "member": "Mitglied",
    "role": "Rolle",
    "added": "Hinzugefügt",
    "analyses": "Analysen",
    "tickets": "Tickets",
    "creator": "Ersteller",
    "admin": "Admin",
    "siteManager": "Bauleiter",
    "superuser": "Superuser",
    "errorLoading": "Fehler beim Laden",
    "errorLoadingMembers": "Fehler beim Laden der Teammitglieder",
    "retryButton": "Erneut versuchen",
    "noMembersFound": "Keine Teammitglieder gefunden",
    "noSearchResults": "Keine Teammitglieder entsprechen deiner Suche",
    "inviteFirstMember": "Lade dein erstes Teammitglied ein",
    "inviteFirstMemberButton": "Erstes Mitglied einladen",
    "inviteMemberDialog": "Teammitglied einladen",
    "emailRequired": "E-Mail ist erforderlich",
    "invitationSent": "Einladung erfolgreich versendet!",
    "errorSendingInvitation": "Fehler beim Senden der Einladung",
    "invitedBy": "Eingeladen von {name}",
    "email": "E-Mail",
    "name": "Name",
    "optional": "(optional)",
    "emailPlaceholder": "mitarbeiter@firma.de",
    "namePlaceholder": "z.B. Max Mustermann",
    "info": "ℹ️ Info:",
    "infoText": "Das Teammitglied erhält die Rolle \"Bauleiter\" und kann Analysen erstellen und Tickets verwalten.",
    "cancel": "Abbrechen",
    "sendInvitation": "Einladung senden",
    "sending": "Wird versendet..."
  },
  "projectAnalyses": {
    "title": "Analysen",
    "back": "Zurück",
    "errorLoading": "Fehler beim Laden der Analysen",
    "errorLoadingTitle": "Fehler beim Laden",
    "retryButton": "Erneut versuchen",
    "pagination": "Seite {page} von {pages} · Gesamt: {total} Analysen",
    "statusFilter": "Status filtern",
    "allStatuses": "Alle Status",
    "statusCompleted": "Abgeschlossen",
    "statusProcessing": "Verarbeitung",
    "statusFailed": "Fehler",
    "showingRange": "Zeige {from} bis {to} von {total}",
    "previous": "Zurück",
    "next": "Weiter",
    "imageAlt": "Analyse",
    "defectsCount": "{count} Mängel",
    "noAnalysesFound": "Keine Analysen gefunden",
    "noAnalysesYet": "Noch keine Analysen vorhanden"
  },
  "projectTickets": {
    "title": "Mangelanzeigen",
    "back": "Zurück",
    "errorLoading": "Fehler beim Laden der Tickets",
    "errorLoadingTitle": "Fehler beim Laden",
    "retryButton": "Erneut versuchen",
    "pagination": "Seite {page} von {pages} · Gesamt: {total} Tickets",
    "statusFilter": "Status filtern",
    "allStatuses": "Alle Status",
    "statusOpen": "Offen",
    "statusInReview": "In Prüfung",
    "statusCompleted": "Erledigt",
    "newTicket": "Neues Ticket",
    "showingRange": "Zeige {from} bis {to} von {total}",
    "previous": "Zurück",
    "next": "Weiter",
    "defectsCount": "{count} Mängel",
    "createdAgo": "Erstellt {time}",
    "dueDate": "Fällig: {date}",
    "overdue": "Überfällig",
    "noTicketsFound": "Keine Tickets gefunden",
    "noTicketsYet": "Noch keine Tickets vorhanden"
  },
  "adminDashboard": {
    "title": "Admin Dashboard",
    "usersCount": "{count} Benutzer",
    "loadingUsers": "... Benutzer",
    "addUser": "Benutzer hinzufügen",
    "searchPlaceholder": "Suche nach Benutzer-Email oder Name...",
    "filterAll": "Alle Benutzer",
    "filterActive": "Aktive Abos",
    "filterOverLimit": "Limit überschritten",
    "statsActiveUsers": "Aktive Benutzer",
    "statsTotalAnalyses": "Gesamt-Analysen",
    "statsOverLimit": "Limit überschritten",
    "statsPeriod": "Zeitraum",
    "quickActions": "Schnellaktionen",
    "manageUsers": "Benutzer verwalten",
    "contractors": "Auftragnehmer",
    "emailTemplates": "Email Templates",
    "settings": "Einstellungen",
    "userUsage": "Benutzer-Nutzung",
    "noUsersFound": "Keine Benutzer gefunden",
    "tryOtherFilters": "Versuchen Sie andere Filtereinstellungen",
    "noDataAvailable": "Keine Nutzungsdaten für diesen Monat verfügbar",
    "limitBadge": "Limit",
    "until": "Bis:",
    "ofAnalyses": "/ {limit} Analysen",
    "percentUsed": "% genutzt",
    "paginationInfo": "Seite {current} von {total} • {count} Benutzer",
    "accessDenied": "Zugriff verweigert",
    "accessDeniedMessage": "Diese Seite ist nur für Administratoren zugänglich.",
    "goHome": "Zur Startseite"
  },
  "adminUsers": {
    "title": "Benutzerverwaltung",
    "description": "Verwalte Benutzer und sende Einladungen",
    "searchPlaceholder": "Benutzer durchsuchen...",
    "inviteUser": "Benutzer einladen",
    "tableHeaderUser": "Benutzer",
    "tableHeaderRole": "Rolle",
    "tableHeaderCreated": "Erstellt",
    "tableHeaderActions": "Aktionen",
    "editUser": "Benutzer bearbeiten",
    "deleteUser": "Benutzer löschen",
    "noUsersFound": "Keine Benutzer gefunden",
    "noSearchResults": "Keine Benutzer entsprechen deiner Suche",
    "inviteFirstUser": "Lade deinen ersten Benutzer ein",
    "inviteFirstUserButton": "Ersten Benutzer einladen",
    "inviteDialogTitle": "Benutzer einladen",
    "emailRequired": "E-Mail *",
    "emailPlaceholder": "benutzer@firma.de",
    "roleRequired": "Rolle *",
    "nameOptional": "Name",
    "nameOptionalLabel": "(optional)",
    "namePlaceholder": "z.B. Max Mustermann",
    "infoLabel": "ℹ️ Info:",
    "infoText": "Der Benutzer erhält eine E-Mail mit einem Link zum Festlegen seines Passworts und Vervollständigen des Profils.",
    "cancel": "Abbrechen",
    "sendInvitation": "Einladung senden",
    "sending": "Wird versendet...",
    "emailRequiredError": "E-Mail ist erforderlich",
    "invalidEmailError": "Ungültiges E-Mail-Format (z.B. name@firma.de)",
    "invitationSent": "Einladung erfolgreich versendet!",
    "invitationError": "Fehler beim Versenden der Einladung",
    "roleAdmin": "Admin",
    "roleSiteManager": "Bauleiter",
    "editModalTitle": "Benutzer bearbeiten",
    "featureInDevelopment": "Feature in Entwicklung",
    "editFeatureComingSoon": "Die Benutzer-Bearbeitung wird bald verfügbar sein.",
    "selectedUser": "Ausgewählter Benutzer:",
    "close": "Schließen",
    "deleteModalTitle": "Benutzer löschen",
    "deleteConfirmation": "Benutzer unwiderruflich löschen?",
    "deleteWarning": "Diese Aktion kann nicht rückgängig gemacht werden. Der Benutzer wird komplett aus dem System entfernt.",
    "userLabel": "Benutzer:",
    "roleLabel": "Rolle:",
    "emailLabel": "E-Mail:",
    "deleteButton": "Endgültig löschen",
    "deleting": "Wird gelöscht...",
    "userDeleted": "Benutzer {email} wurde gelöscht",
    "deleteError": "Fehler beim Löschen des Benutzers",
    "csvRoleHint": "Format: E-Mail, Name, Rolle — Rolle ist optional (Standard: SITE_MANAGER). Mögliche Rollen: SITE_MANAGER oder ADMIN.",
    "csvImport": "CSV Import",
    "csvTitle": "Benutzer importieren",
    "csvDownloadTemplate": "Vorlage herunterladen",
    "csvUploadFile": "CSV-Datei hochladen",
    "csvDragDrop": "CSV-Datei hierher ziehen oder klicken zum Auswählen",
    "csvOrPaste": "oder Text einfügen:",
    "csvPastePlaceholder": "max@firma.de;Max Mustermann;SITE_MANAGER\nanna@firma.de;Anna Schmidt;ADMIN",
    "csvParsePreview": "Vorschau laden",
    "csvPreview": "Vorschau ({count} Benutzer)",
    "csvHeaderEmail": "E-Mail",
    "csvHeaderName": "Name",
    "csvHeaderRole": "Rolle",
    "csvHeaderStatus": "Status",
    "csvValid": "OK",
    "csvInvalidEmail": "Ungültige E-Mail",
    "csvInvalidRole": "Ungültige Rolle (SITE_MANAGER oder ADMIN)",
    "csvDuplicate": "Doppelt in CSV",
    "csvNoValidEntries": "Keine gültigen Einträge gefunden",
    "csvImportButton": "Importieren ({count} Benutzer)",
    "csvImporting": "Importiere...",
    "csvCancel": "Abbrechen",
    "csvSuccess": "{succeeded} von {total} Benutzer erstellt",
    "csvError": "Fehler beim Import",
    "csvResultCreated": "Erstellt",
    "csvResultEmailFailed": "Erstellt (E-Mail fehlgeschlagen!)",
    "csvFileLoaded": "CSV geladen ({count} Zeilen)",
    "csvAllValid": "Alle Einträge gültig",
    "csvHasErrors": "{count} Einträge mit Fehlern"
  },
  "emailTemplates": {
    "title": "E-Mail Templates",
    "description": "Verwalte deine Mängelmeldungs-Vorlagen",
    "newTemplate": "Neues Template",
    "searchPlaceholder": "Templates durchsuchen...",
    "availableVariables": "Verfügbare Variablen:",
    "noTemplatesFound": "Keine Templates gefunden",
    "noSearchResults": "Keine Templates entsprechen deiner Suche",
    "createFirstTemplate": "Erstelle dein erstes Template",
    "createFirstTemplateButton": "Erstes Template erstellen",
    "standard": "Standard",
    "subject": "Betreff:",
    "createdBy": "Erstellt von {name} am {date}",
    "editTemplate": "Template bearbeiten",
    "deleteTemplate": "Template löschen",
    "newTemplateTitle": "Neues Template",
    "editTemplateTitle": "Template bearbeiten",
    "nameRequired": "Name *",
    "namePlaceholder": "z.B. Standard Mängelmeldung",
    "setAsDefault": "Als Standard setzen",
    "subjectRequired": "Betreff *",
    "subjectPlaceholder": "z.B. Mängelmeldung - {{projektName}} - Frist: {{frist}}",
    "htmlEditor": "HTML Editor",
    "preview": "Vorschau",
    "htmlContentPlaceholder": "HTML-Inhalt der E-Mail",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "create": "Erstellen",
    "templateUpdated": "Template aktualisiert",
    "templateCreated": "Template erstellt",
    "saveError": "Fehler beim Speichern",
    "deleteConfirmation": "Template wirklich löschen?",
    "templateDeleted": "Template gelöscht",
    "deleteError": "Fehler beim Löschen",
    "comingSoonTitle": "Feature kommt bald",
    "comingSoonMessage": "Template-Erstellung ist in Entwicklung und wird in Kürze verfügbar sein.",
    "understood": "Verstanden",
    "defaultTemplate": {
      "subject": "Mängelmeldung",
      "greeting": "Sehr geehrte/r {{ansprechpartner}},",
      "intro": "im Projekt <strong>{{projektName}}</strong> wurden <strong>{{anzahlMaengel}}</strong> Mängel festgestellt, die bis zum <strong>{{frist}}</strong> behoben werden müssen.",
      "hintsLabel": "Hinweise:",
      "contact": "Bitte setzen Sie sich bei Fragen mit uns in Verbindung.",
      "signature": "Mit freundlichen Grüßen,<br>Ihr ZeroSnag Team",
      "footer": "Diese E-Mail wurde automatisch von ZeroSnag generiert.",
      "exampleProject": "Beispielprojekt Heidelberg",
      "exampleDeadline": "15.12.2025",
      "exampleCount": "3",
      "exampleCompany": "Musterfirma GmbH",
      "exampleContact": "Max Mustermann",
      "exampleNotes": "Bitte beachten Sie die beigefügten Fotos."
    }
  },
  "systemSettings": {
    "accessDeniedTitle": "Zugriff verweigert",
    "accessDeniedMessage": "Nur SUPERUSER (SaaS-Administratoren) haben Zugriff auf System-Einstellungen.",
    "accessDeniedToast": "Nur SUPERUSER haben Zugriff auf System-Einstellungen",
    "loadingSettings": "Lädt Einstellungen...",
    "title": "System-Einstellungen",
    "subtitle": "SUPERUSER - Globale System-Konfiguration",
    "tabGemini": "KI-Einstellungen",
    "tabDetection": "Erkennung",
    "tabTrades": "Gewerke",
    "tabDefects": "Mängel",
    "tabOffline": "Offline",
    "tabData": "Daten",
    "unsavedChanges": "Ungespeicherte Änderungen",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "saving": "Speichert...",
    "geminiTitle": "KI-Konfiguration",
    "geminiDescription": "API-Einstellungen für die KI-gestützte Mängelerkennung",
    "geminiApiKeyLabel": "API-Schlüssel",
    "geminiApiKeyPlaceholder": "API-Key eingeben...",
    "geminiApiKeyHelper": "KI API Key - wird für alle Analysen verwendet",
    "geminiModelLabel": "Modell",
    "geminiModelPlaceholder": "KI-Modell",
    "geminiModelHelper": "Das verwendete KI-Modell für Analysen",
    "analysisLanguageLabel": "KI-Analysesprache (Systemweit)",
    "analysisLanguageHelper": "Diese Sprache gilt für ALLE KI-generierten Inhalte (Analysen, Mängelbeschreibungen, Lösungen). Mängel-Typen bleiben auf Englisch für Konsistenz.",
    "geminiPromptLabel": "System Prompt",
    "geminiPromptPlaceholder": "Analysiere dieses Baubild auf potenzielle Mängel...",
    "geminiPromptHelper": "Instruktionen für die KI - definiert was und wie analysiert wird",
    "detectionTitle": "Erkennungsparameter",
    "detectionDescription": "Feinabstimmung der Mängelerkennung",
    "detectionConfidenceLabel": "Konfidenzschwelle",
    "detectionConfidenceHelper": "Mindest-Konfidenz für erkannte Mängel",
    "detectionMaxLabel": "Maximale Erkennungen",
    "detectionMaxHelper": "Maximale Anzahl Mängel pro Analyse",
    "tradesTitle": "Gewerke-Verwaltung",
    "tradesDescription": "Verfügbare Gewerke für die Mängelerkennung",
    "tradesActiveLabel": "Aktivierte Gewerke",
    "tradesCustomLabel": "(Benutzerdefiniert)",
    "tradesAddLabel": "Neues Gewerk hinzufügen",
    "tradesAddPlaceholder": "z.B. Malerarbeiten",
    "tradesAddButton": "Hinzufügen",
    "tradesDefaultHeating": "Heizung",
    "tradesDefaultVentilation": "Lüftung",
    "tradesDefaultPlumbing": "Sanitär",
    "tradesDefaultDrywall": "Trockenbau",
    "tradesDefaultElectrical": "Elektro",
    "defectsTitle": "Mängel-Verwaltung",
    "defectsDescription": "Verfügbare Mängel-Kategorien für die Erkennung",
    "defectsActiveLabel": "Aktivierte Mängel",
    "defectsCustomLabel": "(Benutzerdefiniert)",
    "defectsAddLabel": "Neue Mangel-Kategorie hinzufügen",
    "defectsAddPlaceholder": "z.B. Fehlende Abdichtung",
    "defectsAddButton": "Hinzufügen",
    "defectsDefaultMissingInsulation": "Fehlende Isolierung",
    "defectsDefaultMissingLabeling": "Fehlende Beschriftung",
    "defectsDefaultMissingGrounding": "Fehlende Erdung",
    "defectsDefaultExposedWiring": "Freiliegende Kabel",
    "defectsDefaultWrongSpacing": "Fehlender Kantenschutz",
    "defectsDefaultContamination": "Verschmutzung/Bauschutt",
    "defectsDefaultImproperInstallation": "Unsachgemäße Installation",
    "defectsDefaultSafetyHazard": "Sicherheitsrisiko",
    "defectsDefaultMaterialDefect": "Materialmangel",
    "offlineTitle": "Offline-Modus",
    "offlineDescription": "Einstellungen für den Offline-Betrieb der App",
    "offlineAutoSyncLabel": "Automatische Synchronisation",
    "offlineAutoSyncHelper": "Offline-Analysen automatisch synchronisieren wenn Online",
    "offlineMaxQueueLabel": "Maximale Warteschlangen-Größe",
    "offlineMaxQueueValue": "{count} Analysen",
    "offlineMaxQueueHelper": "Maximale Anzahl offline gespeicherter Analysen",
    "offlinePushLabel": "Push-Benachrichtigungen",
    "offlinePushHelper": "Benachrichtigungen für Sync-Status und Fehler",
    "dataTitle": "Daten-Verwaltung",
    "dataDescription": "Import und Export von System-Einstellungen",
    "dataWarning": "Achtung: Import überschreibt alle aktuellen Einstellungen!",
    "dataExportLabel": "Einstellungen exportieren",
    "dataExportHelper": "Exportiert alle System-Einstellungen als JSON-Datei",
    "dataExportButton": "Exportieren",
    "dataImportLabel": "Einstellungen importieren",
    "dataImportHelper": "Importiert System-Einstellungen aus einer JSON-Datei",
    "dataExportSuccess": "Einstellungen exportiert",
    "dataImportSuccess": "Einstellungen importiert",
    "dataImportError": "Fehler beim Importieren: Ungültige JSON-Datei",
    "tabFeatures": "Features",
    "featuresTitle": "Feature-Verwaltung",
    "featuresDescription": "Funktionen aktivieren oder deaktivieren. Nur SUPERUSER kann Features umschalten. Berechtigte Rollen sehen das Feature, wenn es aktiviert ist.",
    "featuresAllowedRoles": "Berechtigte Rollen",
    "tabApp": "App-Update",
    "appTitle": "Erzwungenes App-Update",
    "appDescription": "Blockiert native Apps unterhalb einer Mindestversion, bis Nutzer aus dem App Store / Play Store aktualisieren.",
    "appMinVersionLabel": "Mindest-App-Version",
    "appMinVersionPlaceholder": "z. B. 1.3.0",
    "appMinVersionHelper": "Native Apps unter dieser Version zeigen einen Sperrbildschirm. Leer lassen = kein Zwang.",
    "appMinVersionWarning": "Nur auf eine Version setzen, die bereits im Store veröffentlicht ist – sonst werden Nutzer blockiert, ohne aktualisieren zu können. Wirkt nach ~60 Sekunden. Gilt nur für die native App; Web aktualisiert sich automatisch."
  },
  "login": {
    "title": "Anmelden",
    "subtitle": "Melden Sie sich an, um fortzufahren",
    "emailLabel": "E-Mail",
    "emailPlaceholder": "ihre.email@test.com",
    "passwordLabel": "Passwort",
    "passwordPlaceholder": "Ihr Passwort",
    "loginButton": "Anmelden",
    "loggingIn": "Wird angemeldet...",
    "loginFailed": "Login fehlgeschlagen",
    "invalidCredentials": "Ungültige Anmeldedaten"
  },
  "setupPassword": {
    "title": "Passwort festlegen",
    "subtitle": "Willkommen bei ZeroSnag! Legen Sie Ihr Passwort fest, um loszulegen.",
    "newPasswordLabel": "Neues Passwort *",
    "newPasswordPlaceholder": "Mindestens 8 Zeichen",
    "confirmPasswordLabel": "Passwort bestätigen *",
    "confirmPasswordPlaceholder": "Passwort wiederholen",
    "passwordRequirements": "Passwort-Anforderungen:",
    "requirementMinLength": "Mindestens 8 Zeichen",
    "requirementMatch": "Passwörter stimmen überein",
    "setPasswordButton": "Passwort festlegen & Einloggen",
    "settingPassword": "Passwort wird gesetzt...",
    "roleLabel": "Rolle:",
    "roleAdmin": "Administrator",
    "roleSiteManager": "Bauleiter",
    "invalidLink": "Ungültiger Link",
    "invalidLinkDescription": "Dieser Einladungslink ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen Link an.",
    "goToLoginButton": "Zur Anmeldung",
    "alreadySetup": "Bereits eingerichtet",
    "alreadySetupDescription": "Sie sind bereits angemeldet und haben Ihr Passwort bereits festgelegt.",
    "goToAppButton": "Zur App",
    "errorProcessingInvite": "Fehler beim Verarbeiten des Einladungslinks",
    "inviteLinkUsed": "Dieser Einladungslink wurde bereits verwendet",
    "passwordsDontMatch": "Passwörter stimmen nicht überein",
    "passwordTooShort": "Passwort muss mindestens 8 Zeichen lang sein",
    "errorSettingPassword": "Fehler beim Setzen des Passworts: {error}",
    "passwordSetSuccess": "Passwort erfolgreich gesetzt! Sie werden eingeloggt...",
    "unknownError": "Unbekannter Fehler"
  },
  "confirmEmail": {
    "title": "E-Mail bestätigen",
    "subtitle": "Klicken Sie auf den Button, um Ihre E-Mail-Adresse zu bestätigen.",
    "confirmButton": "E-Mail bestätigen",
    "confirming": "Wird bestätigt...",
    "doneTitle": "E-Mail bestätigt",
    "doneDescription": "Vielen Dank! Wir prüfen Ihre Anfrage und schalten Ihren Zugang frei. Sie erhalten eine E-Mail, sobald es losgehen kann.",
    "invalidTitle": "Link ungültig",
    "invalidDescription": "Dieser Bestätigungslink ist ungültig oder wurde bereits verwendet. Bitte registrieren Sie sich erneut.",
    "goToLoginButton": "Zur Anmeldung"
  },
  "resetPassword": {
    "title": "Neues Passwort setzen",
    "subtitle": "Vergeben Sie ein neues Passwort für Ihr ZeroSnag-Konto.",
    "newPasswordLabel": "Neues Passwort",
    "newPasswordPlaceholder": "Mindestens 8 Zeichen",
    "confirmPasswordLabel": "Passwort bestätigen",
    "confirmPasswordPlaceholder": "Passwort wiederholen",
    "requirementMinLength": "Mindestens 8 Zeichen",
    "requirementMatch": "Passwörter stimmen überein",
    "saveButton": "Passwort speichern",
    "saving": "Speichern...",
    "passwordMismatch": "Die Passwörter stimmen nicht überein.",
    "passwordTooShort": "Das Passwort muss mindestens 8 Zeichen lang sein.",
    "updateFailed": "Passwort konnte nicht gesetzt werden: {error}",
    "sessionLost": "Sitzung verloren. Bitte den Link erneut anfordern.",
    "success": "Passwort geändert — Sie sind jetzt angemeldet.",
    "invalidTitle": "Link ungültig oder abgelaufen",
    "invalidDescription": "Bitte fordern Sie über „Passwort vergessen?\" bei der Anmeldung einen neuen Link an.",
    "toLogin": "Zur Anmeldung",
    "unknownError": "Unbekannter Fehler"
  },
  "completeProfile": {
    "title": "Willkommen bei ZeroSnag!",
    "subtitle": "Vervollständigen Sie Ihr Profil, um loszulegen",
    "emailLabel": "E-Mail",
    "nameLabel": "Name",
    "nameOptional": "(optional)",
    "namePlaceholder": "z.B. Max Mustermann",
    "companyLabel": "Firma",
    "companyOptional": "(optional)",
    "companyPlaceholder": "z.B. Implenia AG",
    "saveButton": "Profil vervollständigen",
    "saving": "Wird gespeichert...",
    "footerNote": "Nach dem Speichern können Sie sich mit Ihrer E-Mail und Ihrem Passwort anmelden",
    "acceptInviteFirst": "Bitte akzeptieren Sie zuerst die Einladungs-E-Mail",
    "sessionExpired": "Sitzung abgelaufen. Bitte melden Sie sich erneut an.",
    "profileCompletedSuccess": "Profil erfolgreich vervollständigt!",
    "profileCreateFailed": "Profil konnte nicht erstellt werden",
    "profileCreatedJoinTeamFailed": "Profil erstellt, aber Fehler beim Hinzufügen zum Projektteam",
    "unknownError": "Profil konnte nicht vervollständigt werden"
  },
  "billing": {
    "title": "Abrechnung & Nutzung",
    "subtitle": "Verwalte dein Abonnement und überwache die Nutzung",
    "currentSubscription": "Aktuelles Abonnement",
    "subscriptionName": "ZeroSnag Professional",
    "status": {
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "canceled": "Gekündigt"
    },
    "until": "bis",
    "price": "Preis:",
    "priceAmount": "€49/Monat",
    "manageSubscription": "Abonnement verwalten",
    "fairUseLimit": "Fair Use: 5.000 Analysen pro Monat",
    "subscribeNow": "Jetzt abonnieren",
    "securePayment": "Sichere Zahlung über Stripe",
    "loading": "Lädt...",
    "currentUsage": "Aktuelle Nutzung - {month}",
    "analysesOf": "von {limit} Analysen",
    "percentUsed": "{percent}% genutzt",
    "limitExceeded": "Limit überschritten",
    "limitExceededTitle": "Fair Use Limit überschritten",
    "limitExceededMessage": "Sie haben das monatliche Limit von {limit} Analysen überschritten.",
    "usageHistory": "Nutzungs-Historie",
    "totalAnalyses": "Gesamt: {count} Analysen",
    "analyses": "Analysen",
    "featuresTitle": "ZeroSnag Professional - €49/Monat",
    "featuresDescription": "Mit ZeroSnag Professional erhältst du Zugriff auf bis zu 5.000 KI-Analysen pro Monat. Das reicht für die meisten Bauprojekte vollkommen aus.",
    "featureUnlimitedProjects": "Unbegrenzte Projekte und Auftragnehmer",
    "featureEmailNotifications": "Email-Benachrichtigungen inklusive",
    "featureAiDetection": "Automatische Mängelerkennung mit KI",
    "featureOfflineMode": "Offline-Modus und App-Support",
    "featureExport": "Export-Funktionen (JSON, PDF)",
    "featureAnalysesPerMonth": "Bis zu 5.000 Analysen/Monat",
    "toastDemoMode": "Stripe Demo-Modus: {message}",
    "toastCheckoutError": "Fehler beim Erstellen der Checkout-Session",
    "toastGeneralError": "Fehler: {message}",
    "toastNoBillingAccount": "Für dieses Konto gibt es noch kein Abo. Buchen Sie zuerst eine Lizenz.",
    "cancelsAtPeriodEnd": "Gekündigt — Ihr Zugang endet am {date}."
  },
  "ticketSubmit": {
    "loadingTicket": "Loading ticket...",
    "ticketNotFound": "Ticket not found",
    "ticketNotFoundDescription": "This ticket could not be loaded or does not exist.",
    "title": "Mängelbeseitigung",
    "deadline": "Deadline:",
    "location": "Ort:",
    "defectsDetected": "{count} Mängel erkannt",
    "defectsToFix": "Zu behebende Mängel",
    "uploadPhotosTitle": "Fotos der Behebung hochladen",
    "uploadPhotosDescription": "Tippen um Fotos aufzunehmen",
    "uploadedPhotos": "{count}/5 Fotos hochgeladen",
    "optionalNote": "💬 Optionale Anmerkung",
    "notePlaceholder": "Fügen Sie hier Anmerkungen zu den Reparaturarbeiten hinzu...",
    "charactersRemaining": "{count}/500 Zeichen",
    "markAsCompleteButton": "Als erledigt markieren",
    "confirmationTitle": "Fertigstellung bestätigen",
    "confirmationMessage": "Sind Sie sicher, dass alle Mängel behoben wurden und Sie dieses Ticket einreichen möchten?",
    "confirmYes": "Ja, einreichen",
    "confirmSubmitting": "Wird eingereicht...",
    "confirmCancel": "Abbrechen",
    "alertMinPhotos": "Bitte laden Sie mindestens ein Foto der abgeschlossenen Arbeiten hoch.",
    "alertSuccess": "Erfolgreich eingereicht! Das Ticket wurde als erledigt markiert.",
    "alertError": "Fehler beim Einreichen. Bitte versuchen Sie es erneut.",
    "completedTitle": "Bereits eingereicht",
    "completedDescription": "Dieses Ticket wurde abgeschlossen",
    "completedMessage": "Vielen Dank! Dieses Ticket wurde bereits eingereicht und als erledigt markiert.",
    "project": "Projekt:",
    "inReviewTitle": "In Bearbeitung",
    "inReviewDescription": "Ihre Einreichung wird geprüft",
    "inReviewMessage": "Vielen Dank! Ihre Einreichung wurde erhalten und wird derzeit vom Bauleiter geprüft.",
    "inReviewNotification": "Sie erhalten eine Benachrichtigung, sobald das Ticket abgeschlossen ist.",
    "invalidTitle": "Ungültiges Ticket",
    "invalidDescription": "Dieses Ticket ist nicht mehr verfügbar",
    "invalidMessage": "Dieses Ticket wurde gelöscht oder ist nicht mehr gültig.",
    "invalidContact": "Bitte wenden Sie sich an den Bauleiter.",
    "notFound": {
      "title": "Ticket nicht gefunden",
      "subtitle": "Dieses Ticket ist nicht mehr verfügbar",
      "reasonsTitle": "Was könnte passiert sein?",
      "reason1": "Das Ticket wurde gelöscht",
      "reason2": "Die Ticket-ID ist falsch",
      "reason3": "Das Ticket ist abgelaufen",
      "reason4": "Der QR-Code oder Link ist beschädigt",
      "contactMessage": "Bitte kontaktieren Sie den Bauleiter für Unterstützung oder fordern Sie ein neues Ticket an.",
      "helpTitle": "Brauchen Sie Hilfe?",
      "helpMessage": "Wenden Sie sich an Ihren Bauleiter oder Projektkoordinator für Unterstützung bei diesem Ticket.",
      "footerTitle": "ZeroSnag Bauqualitätssystem",
      "footerSubtitle": "ZeroSnag - Bauqualitätsmanagement"
    },
    "error": {
      "title": "Oops! Etwas ist schiefgelaufen",
      "subtitle": "Beim Laden dieses Tickets ist ein Fehler aufgetreten. Dies könnte ein vorübergehendes Problem sein.",
      "retryButton": "Erneut versuchen",
      "supportMessage": "Wenn dieses Problem weiterhin besteht, wenden Sie sich bitte an den Support."
    },
    "progressSubmitted": "Mängel eingereicht",
    "uploadButton": "Fotos hochladen (max. 5)",
    "markDone": "Als erledigt melden",
    "submitting": "Wird gesendet...",
    "statusApproved": "Freigegeben",
    "statusPending": "Wartet auf Freigabe",
    "statusRejected": "Nachbesserung nötig",
    "reviewNote": "Rückmeldung"
  },
  "ticketSubmitCompleted": {
    "successTitle": "Erfolgreich!",
    "successDescription": "Ihre Arbeit wurde erfolgreich eingereicht",
    "nextStepsTitle": "Wie geht es weiter?",
    "nextStep1": "• Der Bauleiter wird Ihre Fotos prüfen",
    "nextStep2": "• Der Ticket-Status wird im System aktualisiert",
    "nextStep3": "• Sie werden kontaktiert, falls Klärungsbedarf besteht",
    "thankYouMessage": "Vielen Dank für die professionelle Durchführung der Mängelbeseitigung.",
    "questionsContact": "Fragen? Kontaktieren Sie den Bauleiter",
    "ticketId": "Ticket ID:",
    "footerBrand": "ZeroSnag Bauqualitätssystem"
  },
  "defectSolutions": {
    "button": "Lösung",
    "availableSolutions": "Verfügbare Lösungen",
    "loading": "Lade Lösungsvorschläge...",
    "title": "Lösungsvorschlag",
    "tabSolutions": "Lösungen",
    "solutionNumber": "Lösung {number}",
    "noStandards": "Keine spezifischen Normen hinterlegt",
    "noPrevention": "Keine Präventionsmaßnahmen hinterlegt"
  },
  "analysisDetailsModal": {
    "title": "Analyse-Details",
    "edit": "Bearbeiten",
    "promptPlaceholder": "Zusätzliche Details für KI (optional)",
    "examplePlaceholder": "z.B. 'Wasserleitungen im Keller prüfen' oder 'Elektroinstallation 2. OG kontrollieren'",
    "shortcuts": "Strg+Enter zum Speichern · Esc zum Schließen",
    "cancel": "Abbrechen",
    "save": "Speichern"
  },
  "locationDetailsModal": {
    "title": "Standortdetails",
    "edit": "Bearbeiten",
    "placeholder": "z.B. 3. OG, Raum 214",
    "cancelWithShortcut": "Abbrechen (Esc)",
    "saveWithShortcut": "Speichern (Enter)"
  },
  "analysisModal": {
    "selectProject": "Projekt wählen",
    "noProject": "Kein Projekt",
    "versionsCount": "{count} Versionen",
    "versions": "{count} Versionen",
    "noDefects": "Keine Mängel erkannt"
  },
  "projectSelector": {
    "projectName": "Projektname",
    "description": "Beschreibung",
    "address": "Adresse",
    "namePlaceholder": "z.B. Heidelberg Uniklinik",
    "descriptionPlaceholder": "Optionale Projektbeschreibung",
    "addressPlaceholder": "Projektadresse",
    "selectProject": "Projekt wählen",
    "loading": "Lade Projekte...",
    "noProjects": "Keine Projekte gefunden",
    "newProject": "Neues Projekt anlegen",
    "switch": "Wechseln",
    "analysesAndDefects": "Analysen · Mängel",
    "projectLabel": "Projekt:",
    "createProject": "Projekt erstellen"
  },
  "aiPricing": {
    "priceUpdated": "Preis aktualisiert",
    "description": "Verwalten Sie die KI API-Preise für Kostenberechnung. Preise werden mit jeder Analyse gespeichert für historische Genauigkeit.",
    "noPrices": "Keine Preise konfiguriert. Preise werden automatisch aus der Datenbank geladen.",
    "active": "Aktiv",
    "inputPrice": "Input-Preis",
    "outputPrice": "Output-Preis",
    "inputPricePer1M": "Input-Preis (pro 1M Tokens)",
    "outputPricePer1M": "Output-Preis (pro 1M Tokens)"
  },
  "recentActivity": {
    "noDefects": "Keine Mängel",
    "title": "Letzte Aktivitäten",
    "noActivities": "Noch keine Aktivitäten",
    "noActivitiesDescription": "Starten Sie Ihre erste Analyse, um hier Aktivitäten zu sehen.",
    "showAllActivities": "Alle Aktivitäten anzeigen",
    "pending": "Ausstehend"
  },
  "offlineIndicator": {
    "online": "Online",
    "offline": "Offline",
    "pending": "Ausstehend:",
    "inProgress": "In Bearbeitung:",
    "error": "Fehler:",
    "snagsPending": "{count, plural, one {# Snag wartet} other {# Snags warten}} auf Upload",
    "processingMessage": "Snags werden automatisch hochgeladen, sobald die Verbindung wiederhergestellt ist",
    "retryFailed": "Fehlgeschlagene erneut versuchen",
    "retryPending": "Erneut versuchen",
    "allDone": "Alle Snags verarbeitet",
    "slowConnection": "Langsame Verbindung",
    "slowProcessingMessage": "Upload-Geschwindigkeit zu niedrig — Snags werden hochgeladen, sobald die Verbindung schneller ist"
  },
  "defectSolution": {
    "aiGenerated": "KI-generiert",
    "standards": "Normen",
    "prevention": "Prävention",
    "correctMark": "✓ So ist es richtig",
    "relevantStandards": "Relevante Normen und Vorschriften",
    "preventionMeasures": "Präventionsmaßnahmen",
    "position": "Position"
  },
  "usageWidget": {
    "monthlyUsage": "Monatliche Nutzung",
    "consumption": "Verbrauch",
    "forecastWarning": "Prognose-Warnung",
    "fairUsePolicy": "Fair Use Policy"
  },
  "notificationSettings": {
    "pushNotifications": "Push-Benachrichtigungen",
    "notSupported": "Nicht unterstützt",
    "permissionGranted": "Berechtigung erteilt"
  },
  "tradeBadges": {
    "detectedTrades": "Erkannte Gewerke"
  },
  "backgroundSwitcher": {
    "changeBackground": "Hintergrund ändern",
    "backgroundLabel": "Hintergrund:"
  },
  "defectResults": {
    "analysisResults": "Analyseergebnisse"
  },
  "navbar": {
    "navigation": "Navigation",
    "offlineBanner": "Offline-Modus — nur Bilderfassung verfügbar"
  },
  "feedbackDialog": {
    "menuItem": "Bug melden / Feedback",
    "title": "Bug melden / Feedback",
    "description": "Beschreiben Sie das Problem oder Ihren Vorschlag — die Nachricht geht direkt an das Entwicklerteam.",
    "categoryBug": "Bug",
    "categoryFeedback": "Feedback",
    "messageLabel": "Nachricht",
    "messagePlaceholder": "Was ist passiert? Was haben Sie erwartet?",
    "imageLabel": "Screenshot/Foto (optional)",
    "imageSelect": "Bild auswählen",
    "imageRemove": "Entfernen",
    "imageError": "Bild konnte nicht verarbeitet werden.",
    "submit": "Senden",
    "sending": "Wird gesendet…",
    "success": "Danke! Ihr Feedback wurde gesendet.",
    "error": "Senden fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "offlineHint": "Keine Verbindung — bitte versuchen Sie es später erneut."
  },
  "userProvider": {
    "loadingApp": "Lade ZeroSnag..."
  },
  "performanceMonitor": {
    "navigationLabel": "Navigation:"
  },
  "unifiedImage": {
    "canvasLoading": "Canvas wird geladen...",
    "loadingImage": "Lade Bild...",
    "errorLoading": "Fehler beim Laden des Bildes",
    "defectsDetected": "{count} Mängel erkannt",
    "normalView": "Normal",
    "canvasView": "Canvas",
    "defectsBadge": "{count} Mängel",
    "detectedDefectsLabel": "Erkannte Mängel:"
  },
  "clipboard": {
    "copied": "Link in Zwischenablage kopiert",
    "copyError": "Fehler beim Kopieren"
  },
  "canvas": {
    "clickToSelect": "Klicken zum Auswählen",
    "tapToSelect": "Nochmals tippen zum Auswählen",
    "confidence": "Konfidenz:",
    "uploadingImage": "Lade Bild hoch...",
    "startAnalysis": "Analyse starten",
    "results": "Ergebnisse",
    "orManualCapture": "oder ohne KI-Analyse speichern",
    "addToInspection": "Zu Begehung",
    "createRequest": "Aufforderung"
  },
  "dataExport": {
    "title": "Daten exportieren",
    "timeRangeLabel": "Zeitraum (optional)",
    "fromLabel": "Von",
    "toLabel": "Bis",
    "optionsLabel": "Optionen",
    "includeImageUrls": "Bild-URLs einschließen",
    "selectFormat": "Export-Format wählen",
    "jsonFormat": "Strukturierte Daten",
    "csvFormat": "Tabellendaten",
    "excelFormat": "Arbeitsmappe",
    "exporting": "Exportiere Daten...",
    "gdprNotice": "Hinweis",
    "gdprDescription": "Der Export enthält alle Analysedaten einschließlich Bildern und personenbezogenen Informationen. Bitte beachten Sie die DSGVO-Richtlinien beim Umgang mit diesen Daten.",
    "exportFailed": "Export fehlgeschlagen",
    "exportFailedRetry": "Export fehlgeschlagen. Bitte versuchen Sie es erneut."
  },
  "liveVideo": {
    "analysisInterval": "Analyseintervall:",
    "oneSecond": "1 Sekunde",
    "twoSeconds": "2 Sekunden",
    "fiveSeconds": "5 Sekunden",
    "frames": "Frames:",
    "analyzing": "Analysiert...",
    "ready": "Bereit",
    "defect": "Mangel",
    "defects": "Mängel"
  },
  "camera": {
    "permissionDenied": "Kamera konnte nicht geöffnet werden. Bitte überprüfen Sie die Berechtigung.",
    "openCamera": "Kamera öffnen",
    "uploadImage": "Bild hochladen",
    "instructions": "Nehmen Sie ein Foto auf oder laden Sie ein Bild zur Analyse hoch",
    "capturedImageAlt": "Aufgenommenes Bild",
    "promptHeader": "Foto",
    "promptPhoto": "Aus Mediathek",
    "promptPicture": "Foto aufnehmen",
    "promptCancel": "Abbrechen"
  },
  "email": {
    "common": {
      "autoGenerated": "Diese E-Mail wurde automatisch generiert."
    },
    "tickets": {
      "subject": "Mängelbehebung erforderlich - {{projektName}}",
      "header": "🔧 Mängelbehebung erforderlich",
      "greeting": "Sehr geehrte/r {{ansprechpartner}},",
      "intro": "im Rahmen der Baustelleninspektion für das Projekt wurde im Rahmen unserer Qualitätskontrolle folgende Mängel festgestellt, die wir Sie bitten zeitnah zu beheben:",
      "projectLabel": "Projekt:",
      "locationLabel": "Standort:",
      "deadlineLabel": "Frist zur Behebung:",
      "defectCountLabel": "Anzahl Mängel:",
      "digitalReporting": "📱 Mängel digital melden",
      "qrInstructions": "Scannen Sie diesen QR-Code mit Ihrem Smartphone, um die Behebung direkt zu dokumentieren:",
      "detectedDefects": "Festgestellte Mängel:",
      "notes": "Notizen:",
      "reportingInstructions": "So melden Sie die Behebung:",
      "reportingStep1": "Scannen Sie den QR-Code oder öffnen Sie den untenstehenden Link",
      "reportingStep2": "Laden Sie Fotos der behobenen Mängel hoch",
      "reportingStep3": "Fügen Sie optional Anmerkungen hinzu",
      "reportingStep4": "Bestätigen Sie die Fertigstellung",
      "contactInfo": "Bei Rückfragen wenden Sie sich bitte an den Bauleiter.",
      "signature": "Mit freundlichen Grüßen,<br>Ihr ZeroSnag Team",
      "printTip": "<strong>Tipp:</strong> Drucken Sie diese E-Mail in A4-Format aus und hängen Sie sie vor Ort aus, damit der Auftragnehmer die Mängel vor Ort sehen kann.",
      "severityHigh": "Hoch",
      "severityMedium": "Mittel",
      "severityLow": "Niedrig",
      "ticketLink": "Ticket-Link:",
      "viewTicket": "Ticket ansehen",
      "infoBox": {
        "project": "Projekt",
        "location": "Standort",
        "deadline": "Frist",
        "defectCount": "Anzahl Mängel"
      }
    },
    "fallback": {
      "warning": "⚠️ E-Mail konnte nicht an Auftragnehmer gesendet werden",
      "reason": "Grund:",
      "contractor": "Auftragnehmer:",
      "action": "Aktion:"
    },
    "defectNotification": {
      "subject": "🚨 ZeroSnag: Neuer Mangel in {projectName}",
      "header": "🚨 ZeroSnag Mängelerkennung",
      "subheader": "Neuer Mangel erkannt und bestätigt",
      "projectLabel": "Projekt:",
      "reporterLabel": "Gemeldet von:",
      "timestampLabel": "Zeitstempel:",
      "defectSectionTitle": "🔍 Erkannter Mangel",
      "descriptionLabel": "Beschreibung:",
      "recommendationLabel": "Empfehlung:",
      "imageSectionTitle": "📸 Bild",
      "imageButtonText": "Bild ansehen",
      "actionsSectionTitle": "📋 Nächste Schritte",
      "action1": "Prüfen Sie den Mangel vor Ort",
      "action2": "Weisen Sie den Mangel dem zuständigen Gewerk zu",
      "action3": "Planen Sie die Behebung ein",
      "action4": "Dokumentieren Sie die Behebung in ZeroSnag",
      "footerAutoGenerated": "Diese E-Mail wurde automatisch von ZeroSnag generiert.",
      "footerCopyright": "© 2025 ZeroSnag - KI-gestützte Baustelleninspektion"
    },
    "test": {
      "subject": "ZeroSnag - Test E-Mail",
      "heading": "Test E-Mail",
      "body": "Dies ist eine Test-E-Mail von ZeroSnag.",
      "timestamp": "Zeitstempel:"
    }
  },
  "components": {
    "defectResults": {
      "defectsCount": "{count} Mängel",
      "okCount": "{count} OK",
      "uncertainCount": "{count} Unklar",
      "defectDetected": "Defekt erkannt",
      "noDefectsFound": "Keine Mängel gefunden. Alle {okCount} geprüften Objekte sind in Ordnung.",
      "uncertainObjects": "{count} Objekt{plural} konnte{plural} nicht eindeutig klassifiziert werden."
    },
    "analysisModal": {
      "confidencePercent": "{percent}% Konfidenz",
      "recommendation": "Empfehlung:",
      "reScan": "Re-Scan"
    },
    "projectSelector": {
      "createFirstProject": "Erstes Projekt anlegen",
      "projectName": "Projektname *",
      "description": "Beschreibung",
      "address": "Adresse",
      "createProject": "Projekt erstellen",
      "namePlaceholderExample": "z.B. Heidelberg Uniklinik",
      "descriptionPlaceholder": "Optionale Projektbeschreibung",
      "addressPlaceholder": "Projektadresse",
      "newProject": "Neues Projekt anlegen"
    },
    "usageWidget": {
      "of": "von {limit}",
      "projectionWarning": "Bei aktuellem Verbrauch: <strong>{projectedUsage}</strong> Analysen bis Monatsende. Das ist <strong>{over}</strong> über dem Limit!",
      "fairUseWarning": "Sie nähern sich dem monatlichen Limit. Bei Überschreitung können zusätzliche Gebühren anfallen.",
      "optimalUsage": "✨ Optimale Nutzung! Sie sind gut im Budget für diesen Monat."
    },
    "recentActivity": {
      "analysisIn": "Analyse in {project}"
    },
    "backgroundSwitcher": {
      "paperOnly": "📄 Paper Only",
      "gradientOnly": "🌈 Gradient Only",
      "bothCombined": "✨ Both Combined",
      "noneClean": "⚪ None (Clean)"
    },
    "loginForm": {
      "loginFailed": "Login fehlgeschlagen",
      "subtitle": "Melden Sie sich an, um fortzufahren",
      "email": "E-Mail",
      "emailPlaceholder": "ihre.email@test.com",
      "password": "Passwort",
      "passwordPlaceholder": "Ihr Passwort",
      "signingIn": "Wird angemeldet...",
      "signIn": "Anmelden",
      "forgotLink": "Passwort vergessen?",
      "forgotTitle": "Passwort zurücksetzen",
      "forgotIntro": "Geben Sie Ihre E-Mail-Adresse ein — wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
      "forgotSubmit": "Reset-Link senden",
      "forgotSending": "Wird gesendet...",
      "forgotSent": "Falls ein Konto mit dieser Adresse existiert, haben wir Ihnen eine E-Mail mit einem Link zum Zurücksetzen des Passworts geschickt. Bitte prüfen Sie auch den Spam-Ordner.",
      "forgotFailed": "Anfrage fehlgeschlagen. Bitte später erneut versuchen.",
      "forgotNetworkError": "Netzwerkfehler. Bitte später erneut versuchen.",
      "backToLogin": "Zurück zur Anmeldung",
      "noAccount": "Noch kein Konto?",
      "registerLink": "Kostenlos testen",
      "registerLinkNeutral": "Registrieren"
    },
    "errorBoundary": {
      "title": "Etwas ist schiefgelaufen",
      "description": "Es ist ein unerwarteter Fehler aufgetreten",
      "devModeDetails": "Entwicklermodus: Fehlerdetails anzeigen",
      "retry": "Erneut versuchen"
    },
    "appBanner": {
      "message": "Bitte installieren Sie die App für die beste Stabilität & Performance.",
      "cta": "App laden"
    },
    "mobileTabBar": {
      "dashboard": "Statistiken",
      "detect": "KI Analyse",
      "history": "Historie",
      "projects": "Projekte",
      "tickets": "Tickets"
    },
    "breadcrumbs": {
      "home": "Home"
    },
    "imageCapture": {
      "openCamera": "Kamera öffnen",
      "uploadImage": "Bild hochladen",
      "instructions": "Nehmen Sie ein Foto auf oder laden Sie ein Bild zur Analyse hoch",
      "capturedImageAlt": "Aufgenommenes Bild"
    },
    "tradeBadges": {
      "heating": "Heizung",
      "ventilation": "Lüftung",
      "plumbing": "Sanitär",
      "drywall": "Trockenbau",
      "electrical": "Elektro"
    },
    "qrCode": {
      "copied": "Kopiert!",
      "copyLink": "Link kopieren"
    }
  },
  "pages": {
    "completeProfile": {
      "acceptInviteFirst": "Bitte akzeptieren Sie zuerst die Einladungs-E-Mail",
      "updateError": "Profil konnte nicht aktualisiert werden",
      "joinProjectError": "Profil erstellt, aber Fehler beim Hinzufügen zum Projektteam",
      "success": "Profil erfolgreich vervollständigt!",
      "generalError": "Profil konnte nicht vervollständigt werden",
      "loginHelper": "Nach dem Speichern können Sie sich mit Ihrer E-Mail und Ihrem Passwort anmelden"
    },
    "setupPassword": {
      "inviteLinkError": "Fehler beim Verarbeiten des Einladungslinks",
      "linkAlreadyUsed": "Dieser Einladungslink wurde bereits verwendet",
      "passwordMismatch": "Passwörter stimmen nicht überein",
      "passwordTooShort": "Passwort muss mindestens 8 Zeichen lang sein",
      "setPasswordError": "Fehler beim Setzen des Passworts: {error}",
      "success": "Passwort erfolgreich gesetzt! Sie werden eingeloggt...",
      "invalidLinkTitle": "Ungültiger Link",
      "invalidLinkMessage": "Dieser Einladungslink ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen Link an.",
      "toLogin": "Zur Anmeldung",
      "alreadySetupTitle": "Bereits eingerichtet",
      "alreadySetupMessage": "Sie sind bereits angemeldet und haben Ihr Passwort bereits festgelegt.",
      "toApp": "Zur App",
      "welcomeMessage": "Willkommen bei ZeroSnag! Legen Sie Ihr Passwort fest, um loszulegen.",
      "roleLabel": "Rolle:",
      "newPasswordLabel": "Neues Passwort *",
      "passwordPlaceholder": "Mindestens 8 Zeichen",
      "confirmPasswordLabel": "Passwort bestätigen *",
      "confirmPasswordPlaceholder": "Passwort wiederholen",
      "requirementsTitle": "Passwort-Anforderungen:",
      "requirement8Chars": "Mindestens 8 Zeichen",
      "requirementMatch": "Passwörter stimmen überein",
      "settingPassword": "Passwort wird gesetzt...",
      "submitButton": "Passwort festlegen & Einloggen"
    }
  },
  "time": {
    "seconds": "{seconds} Sekunden",
    "minutes": "{minutes}:{seconds} Minuten"
  },
  "analysisProgress": {
    "starting": "Starte Analyse...",
    "step1": "Initialisiere neuronale Netzwerke...",
    "step2": "Lade Vision-Transformer-Modell...",
    "step3": "Kalibriere Bilderkennungs-Matrix...",
    "step4": "Extrahiere Multi-Skalen-Feature-Maps...",
    "step5": "Führe Convolutional-Layer-Analyse durch...",
    "step6": "Berechne Attention-Mechanismus-Gewichte...",
    "step7": "Analysiere semantische Bildsegmentierung...",
    "step8": "Prozessiere Deep-Learning-Inferenz...",
    "step9": "Evaluiere Objekterkennungs-Heatmaps...",
    "step10": "Optimiere Bounding-Box-Regressionen...",
    "step11": "Korreliere Multi-Modal-Embeddings...",
    "step12": "Finalisiere KI-gestützte Defektklassifikation...",
    "step13": "Validiere Konfidenz-Scores...",
    "almostDone": "Fast fertig...",
    "processing": "Bild wird verarbeitet...",
    "uploadingImage": "Bild wird hochgeladen...",
    "gemini": "KI-Analyse läuft...",
    "defectsFound": "{count} Mängel gefunden",
    "complete": "Analyse abgeschlossen!",
    "queuedOffline": "Analyse zur Warteschlange hinzugefügt",
    "queuedOfflineDescription": "Wird analysiert sobald die Verbindung wiederhergestellt ist",
    "alreadyRunning": "Analyse läuft bereits",
    "alreadyRunningDescription": "Das Ergebnis erscheint gleich in der Historie"
  },
  "app": {
    "tagline": "ZeroSnag - KI-gestützte Baustelleninspektion",
    "metadata": {
      "title": "ZeroSnag - KI-gestützte Mängelerkennung",
      "description": "AI-gestütztes Werkzeug für Bauleiter zur präventiven Vermeidung von Baumängeln"
    }
  },
  "roles": {
    "admin": "Administrator",
    "siteManager": "Bauleiter"
  },
  "lib": {
    "notifications": {
      "defectQueued": "Ihre Mängelerkennung wurde zur Verarbeitung hinzugefügt",
      "defectsFound": "Mängel erkannt",
      "noDefectsFound": "Keine Mängel gefunden - Alles in Ordnung!",
      "processingComplete": "Analysen erfolgreich verarbeitet",
      "processingSuccess": "erfolgreich",
      "processingFailed": "fehlgeschlagen",
      "queuedTitle": "ZeroSnag - Analyse in Warteschlange",
      "processedTitle": "ZeroSnag - Analyse abgeschlossen",
      "offlineQueueTitle": "ZeroSnag - Offline-Warteschlange verarbeitet"
    },
    "timing": {
      "seconds": "{seconds} Sekunden",
      "minutes": "{minutes}:{seconds} Minuten"
    },
    "defects": {
      "otherDefect": "Sonstiges",
      "other": "Other",
      "unknown": "Unbekannt",
      "unknownSeverity": "Unbekannt"
    },
    "trades": {
      "heating": "Heizung",
      "ventilation": "Lüftung",
      "plumbing": "Sanitär",
      "drywall": "Trockenbau",
      "electrical": "Elektro"
    },
    "objectLabels": {
      "pipe": "Rohr",
      "pipes": "Rohre",
      "metalPipe": "Metallrohr",
      "copperPipe": "Kupferrohr",
      "plasticPipe": "Kunststoffrohr",
      "heatingPipe": "Heizungsrohr",
      "valve": "Ventil",
      "ballValve": "Kugelhahn",
      "fitting": "Fitting",
      "cable": "Kabel",
      "cables": "Kabel",
      "electricalWire": "Elektrische Leitung",
      "electricCable": "Stromkabel",
      "wire": "Draht",
      "wires": "Drähte",
      "exposedWire": "Freiliegender Draht",
      "duct": "Kanal",
      "ventilationDuct": "Lüftungskanal",
      "electricalBox": "Verteilerkasten",
      "junctionBox": "Abzweigdose",
      "pipeInsulation": "Rohrisolierung",
      "insulationMaterial": "Isoliermaterial",
      "constructionDebris": "Bauschutt",
      "rubble": "Schutt",
      "dirt": "Schmutz",
      "dust": "Staub",
      "metalSurface": "Metalloberfläche",
      "wall": "Wand",
      "floor": "Boden",
      "ceiling": "Decke",
      "concrete": "Beton",
      "brick": "Ziegel",
      "drywall": "Trockenbau",
      "foamInsulation": "Schaumisolierung",
      "mineralWool": "Mineralwolle",
      "tool": "Werkzeug",
      "ladder": "Leiter",
      "scaffolding": "Gerüst",
      "bucket": "Eimer",
      "box": "Kiste",
      "material": "Material",
      "constructionMaterial": "Baumaterial",
      "damage": "Schaden",
      "crack": "Riss",
      "hole": "Loch",
      "gap": "Lücke",
      "wallOpening": "Wandöffnung",
      "floorOpening": "Bodenöffnung",
      "leak": "Leck",
      "waterDamage": "Wasserschaden",
      "hazard": "Gefahr",
      "danger": "Gefahr",
      "obstacle": "Hindernis",
      "unsafeCondition": "Unsicherer Zustand"
    }
  },
  "slides": {
    "title": "Lösung",
    "solution": "KI-gestützte Mängelerkennung",
    "detectedDefects": "Erkannte Mängel"
  },
  "gewerkePopup": {
    "title": "Zu viele Gewerke erkannt",
    "description": "Es wurden Mängel aus vielen verschiedenen Gewerken erkannt. Sie können die Analyse auf bestimmte Gewerke einschränken, um genauere Ergebnisse zu erhalten.",
    "skip": "Überspringen",
    "reanalyze": "Erneut analysieren ({count})",
    "analyzing": "Analysiere...",
    "defect": "Mangel",
    "defects": "Mängel"
  },
  "telegram": {
    "title": "Bautagebuch",
    "subtitle": "Telegram Bot & Tagesberichte",
    "tabOverview": "Übersicht",
    "tabUsers": "Benutzer",
    "tabMessages": "Nachrichten",
    "tabReports": "Berichte",
    "botStatus": "Bot-Status",
    "botConfigured": "Bot konfiguriert",
    "botNotConfigured": "Bot nicht konfiguriert",
    "totalUsers": "Telegram-Benutzer",
    "linkedUsers": "Verknüpfte Benutzer",
    "messagesToday": "Nachrichten heute",
    "messagesWeek": "Nachrichten diese Woche",
    "reportsWeek": "Berichte diese Woche",
    "finalizedWeek": "Finalisiert diese Woche",
    "telegramId": "Telegram-ID",
    "telegramUser": "Telegram-Benutzer",
    "linkedTo": "Verknüpft mit",
    "notLinked": "Nicht verknüpft",
    "activeProject": "Aktives Projekt",
    "linkUser": "Benutzer verknüpfen",
    "unlinkUser": "Verknüpfung aufheben",
    "selectUser": "ZeroSnag-Benutzer auswählen",
    "noMessages": "Keine Nachrichten gefunden",
    "filterByProject": "Nach Projekt filtern",
    "filterByDate": "Nach Datum filtern",
    "allProjects": "Alle Projekte",
    "text": "Text",
    "photo": "Foto",
    "voice": "Sprachnachricht",
    "location": "Standort",
    "command": "Befehl",
    "transcript": "Transkription",
    "noReports": "Keine Berichte gefunden",
    "reportDate": "Datum",
    "reportStatus": "Status",
    "reportProject": "Projekt",
    "generateReport": "Bericht generieren",
    "editReport": "Bericht bearbeiten",
    "finalizeReport": "Finalisieren & PDF",
    "downloadPdf": "PDF herunterladen",
    "deleteReport": "Bericht löschen",
    "statusDraft": "Entwurf",
    "statusGenerating": "Wird generiert",
    "statusGenerated": "Generiert",
    "statusEdited": "Bearbeitet",
    "statusFinalized": "Finalisiert",
    "summary": "Zusammenfassung",
    "sections": "Abschnitte",
    "weather": "Wetter",
    "entries": "Einträge",
    "projectLocation": "Projektstandort",
    "setLocation": "Standort setzen",
    "searchAddress": "Adresse suchen...",
    "confirmDelete": "Bericht wirklich löschen?",
    "reportGenerated": "Bericht wurde generiert",
    "reportFinalized": "Bericht wurde finalisiert",
    "reportDeleted": "Bericht wurde gelöscht",
    "noProject": "Kein Projekt",
    "quickAction": "Bautagebuch"
  },
  "inspections": {
    "title": "Begehungen",
    "newInspection": "Neue Begehung",
    "inspectionDate": "Begehungsdatum",
    "inspectionTitle": "Bezeichnung",
    "participants": "Teilnehmer",
    "participantName": "Name",
    "participantRole": "Rolle",
    "addParticipant": "Teilnehmer hinzufügen",
    "notes": "Bemerkungen",
    "locationFilter": "Ortsfilter",
    "statusFilter": "Statusfilter",
    "allStatuses": "Alle Status",
    "statusDraft": "Entwurf",
    "statusFinalized": "Abgeschlossen",
    "statusArchived": "Archiviert",
    "addDefects": "Mängel hinzufügen",
    "photoOnly": "Foto (keine Mängel erfasst)",
    "removeDefect": "Entfernen",
    "generatePdf": "PDF erstellen",
    "downloadPdf": "PDF herunterladen",
    "finalize": "Begehung abschließen & versenden",
    "defectCount": "{count} Mängel",
    "noDefects": "Noch keine Mängel zugeordnet",
    "noInspections": "Keine Begehungen vorhanden",
    "noInspectionsDescription": "Erstellen Sie eine neue Begehung, um Mängel zu dokumentieren.",
    "confirmFinalize": "Begehung abschließen? Dies kann nicht rückgängig gemacht werden.",
    "confirmDelete": "Begehung wirklich löschen?",
    "pdfGenerating": "PDF wird erstellt...",
    "pdfReady": "PDF wurde erstellt",
    "created": "Erstellt",
    "createdBy": "Erstellt von",
    "errorLoading": "Fehler beim Laden der Begehungen",
    "errorLoadingTitle": "Fehler beim Laden",
    "retryButton": "Erneut versuchen",
    "showingRange": "Zeige {from} bis {to} von {total}",
    "previous": "Zurück",
    "next": "Weiter",
    "pagination": "Seite {page} von {pages}",
    "createSuccess": "Begehung wurde erstellt",
    "updateSuccess": "Begehung wurde aktualisiert",
    "deleteSuccess": "Begehung wurde gelöscht",
    "finalizeSuccess": "Begehung wurde abgeschlossen",
    "defectsAdded": "Mängel wurden hinzugefügt",
    "defectsRemoved": "Mängel wurden entfernt",
    "selectTickets": "Tickets auswählen",
    "noAvailableTickets": "Keine verfügbaren Tickets",
    "addSelected": "Ausgewählte hinzufügen",
    "contractor": "Unternehmer",
    "deadline": "Frist",
    "severity": "Schweregrad",
    "description": "Beschreibung",
    "location": "Ort",
    "back": "Zurück zum Projekt",
    "new": "Neu",
    "delete": "Löschen",
    "cancel": "Abbrechen",
    "dateFrom": "Von (Datum)",
    "dateTo": "Bis (optional)",
    "dateToHint": "Leer = nur der eine Tag",
    "sameDayPlaceholder": "Gleicher Tag",
    "titlePlaceholder": "z.B. Technische Zustandsbegehung",
    "locationPlaceholder": "z.B. Gebäude A, 3. OG",
    "notesPlaceholder": "Allgemeine Bemerkungen zur Begehung...",
    "statusFilterPlaceholder": "Alle Status (kein Filter)",
    "statusFilterHint": "Nur Tickets mit diesem Status einbeziehen",
    "statusOpen": "Offen",
    "statusInReview": "In Prüfung",
    "statusCompleted": "Erledigt",
    "autoCollectTitle": "Automatische Mängelsammlung",
    "autoCollectDescription": "Alle Mängeltickets und Defekt-Reports aus dem gewählten Zeitraum werden automatisch in die Begehung übernommen. Sie können danach einzelne Einträge entfernen.",
    "submitting": "Mängel werden gesammelt...",
    "createButton": "Begehung erstellen",
    "validationRequired": "Bezeichnung und Datum sind erforderlich",
    "errorCreating": "Fehler beim Erstellen der Begehung",
    "errorAdding": "Fehler beim Hinzufügen",
    "errorRemoving": "Fehler beim Entfernen",
    "errorPdf": "Fehler bei PDF-Erstellung",
    "errorNoPdf": "Kein PDF verfügbar",
    "errorFinalizing": "Fehler beim Abschließen",
    "errorDeleting": "Fehler beim Löschen",
    "noInspectionsYet": "Noch keine Begehungen vorhanden",
    "defaultTrade": "Gewerk",
    "defaultClassification": "Baumangel",
    "image": "Bild",
    "descriptionLabel": "Beschreibung",
    "locationLabel": "Ort",
    "contractorLabel": "Unternehmer",
    "deadlineLabel": "Frist",
    "statusLabel": "Status",
    "tradeLabel": "Gewerk",
    "sectionTag": "Abschnitt / Tag",
    "sectionTagPlaceholder": "z.B. \"EG Flur\", \"3.OG Bad\"",
    "addDialogTitle": "Bilder / Mängel hinzufügen",
    "addToInspection": "Hinzufügen ({count})",
    "noAvailableAnalyses": "Keine verfügbaren Analysen",
    "noLocation": "Ohne Standort",
    "unsorted": "Nicht zugeordnet",
    "sendToContractors": "An Nachunternehmer senden",
    "confirmSendReports": "Mängelberichte an alle zugeordneten Nachunternehmer senden?",
    "defectsLabel": "Mängel",
    "dispatchPending": "Versand ausstehend",
    "photoBadge": "Foto",
    "tradeWizard": {
      "title": "Gewerk zuweisen",
      "description": "Mangel {progress}. Vor dem Abschluss muss jeder Mangel einem Gewerk zugeordnet sein.",
      "noDescription": "Keine Beschreibung",
      "section": "Bereich: {tag}",
      "tradeLabel": "Gewerk",
      "acceptAllDefault": "Rest als Allgemein",
      "back": "Zurück",
      "skip": "Überspringen",
      "next": "Weiter",
      "apply": "Übernehmen",
      "done": "Fertig"
    },
    "dispatch": {
      "title": "Versand bestätigen",
      "loading": "Lade Gewerke und Firmen…",
      "empty": "Keine Mängel in dieser Begehung.",
      "defectCount": "{count} Mängel",
      "pickContractor": "Firma wählen",
      "noEmailSuffix": " — ohne E-Mail",
      "missingEmail": "Firma hat keine E-Mail — Mail entfällt.",
      "noContractor": "Keine Firma für dieses Gewerk im Projekt hinterlegt — Mail entfällt.",
      "manageContractors": "Firmen im Projekt verwalten",
      "deadlineLabel": "Frist zur Mängelbeseitigung",
      "deadlineHint": "Gilt für alle Tickets, die jetzt erstellt werden.",
      "alreadyTicketedHint": "Mängel mit bestehenden Tickets werden übersprungen.",
      "ticketsCreated": "{count, plural, =1 {1 Ticket erstellt} other {# Tickets erstellt}}",
      "ticketsSkipped": "{count, plural, =0 {} =1 {1 Mangel übersprungen (bereits versendet oder ohne Auftragnehmer)} other {# Mängel übersprungen (bereits versendet oder ohne Auftragnehmer)}}",
      "cancel": "Abbrechen",
      "confirm": "Begehung abschließen & versenden",
      "blockedNoContractor": "Es ist keine Firma gewählt — so würde die Begehung abgeschlossen, ohne dass eine Mängelanzeige rausgeht. Bitte mindestens eine Firma wählen oder die Firmen erst im Projekt hinterlegen.",
      "partialContractors": "{count, plural, =1 {Für 1 Gewerk ist keine Firma gewählt — diese Mängel werden nicht versendet.} other {Für # Gewerke ist keine Firma gewählt — diese Mängel werden nicht versendet.}}",
      "alreadySent": "{count, plural, =1 {1 Mangel wurde bereits versendet und wird nicht erneut verschickt.} other {# Mängel wurden bereits versendet und werden nicht erneut verschickt.}}"
    },
    "renameTitle": "Bezeichnung bearbeiten",
    "bulk": {
      "selected": "{count, plural, =1 {1 Mangel ausgewählt} other {# Mängel ausgewählt}}",
      "selectAll": "{count, plural, =1 {1 Mangel auswählen} other {Alle # auswählen}}",
      "selectDefect": "Mangel N{number} auswählen",
      "clearSelection": "Aufheben",
      "sendAction": "An Nachunternehmer senden",
      "sendTitle": "{count, plural, =1 {1 Mangel senden} other {# Mängel senden}}",
      "sendConfirm": "Senden",
      "sendSuccess": "{count, plural, =1 {1 Mangel versendet} other {# Mängel versendet}}",
      "sendError": "Versand fehlgeschlagen.",
      "nothingToSend": "Nichts zu senden — alle ausgewählten Mängel hängen bereits an einem Ticket.",
      "fixedAction": "Als erledigt",
      "reopenAction": "Wieder öffnen",
      "fixedSuccess": "{count, plural, =1 {1 Mangel erledigt} other {# Mängel erledigt}}",
      "reopenSuccess": "{count, plural, =1 {1 Mangel wieder geöffnet} other {# Mängel wieder geöffnet}}",
      "fixedError": "Konnte nicht gespeichert werden.",
      "nothingToTick": "Nur Fotos ausgewählt — hier gibt es nichts abzuhaken.",
      "done": "Erledigt",
      "floor": "Geschoss",
      "unit": "Wohnung",
      "room": "Zimmer",
      "allFloors": "Alle Geschosse",
      "allUnits": "Alle Wohnungen",
      "allRooms": "Alle Zimmer",
      "clearFilter": "Filter zurücksetzen",
      "shown": "{shown} von {total}",
      "doneByContractor": "Freigegeben",
      "tickOffNotAllowed": "Nur intern durch Bauleitung oder Admin.",
      "ticketsClosed": "{count, plural, =1 {1 Ticket geschlossen — keine weiteren Erinnerungen an die Firma.} other {# Tickets geschlossen — keine weiteren Erinnerungen an die Firmen.}}",
      "ticketsReopened": "{count, plural, =1 {1 Ticket wieder geöffnet.} other {# Tickets wieder geöffnet.}}"
    }
  },
  "sync": {
    "connecting": "Verbindung wird hergestellt…",
    "downloading": "Synchronisiere…",
    "firstSyncSetup": "App wird eingerichtet…",
    "firstSyncLoading": "Deine Daten werden geladen…",
    "firstSyncAlmost": "Fast fertig…",
    "uploading": "Lade Änderungen hoch…",
    "offline": "Offline — Änderungen werden gespeichert",
    "queuedImages": "{count, plural, =1 {1 Bild in Warteschlange} other {# Bilder in Warteschlange}}",
    "uploadingImages": "{count, plural, =1 {Lade 1 Bild hoch…} other {Lade # Bilder hoch…}}",
    "queuedEmails": "{count, plural, =1 {1 E-Mail wird gesendet} other {# E-Mails werden gesendet}}",
    "queuedPdfs": "{count, plural, =1 {1 PDF wird erstellt} other {# PDFs werden erstellt}}",
    "reauthRequired": "Bitte erneut anmelden, um die Synchronisierung fortzusetzen.",
    "preparingOffline": "Offline-Modus wird vorbereitet…",
    "inSync": "Synchron",
    "stalled": "{count, plural, =1 {1 Änderung kann nicht synchronisiert werden} other {# Änderungen können nicht synchronisiert werden}}"
  },
  "pwa": {
    "installTitle": "Zum Home-Bildschirm hinzufügen",
    "installBodyIos": "Tippe unten auf Teilen und dann auf „Zum Home-Bildschirm“ — sonst löscht iOS nach 7 Tagen alle lokalen Daten.",
    "dismiss": "OK"
  },
  "appUpdate": {
    "updateRequiredTitle": "Update erforderlich",
    "updateRequiredBody": "Eine neue Version von ZeroSnag ist verfügbar. Bitte aktualisiere die App, um fortzufahren.",
    "updateButton": "Jetzt aktualisieren",
    "newVersionTitle": "Neue Version verfügbar",
    "reloadingIn": "Die App wird in {secs} Sekunden aktualisiert…"
  },
  "demoBanner": {
    "title": "Demo-Zugang.",
    "analysesLeft": "Noch {remaining} von {limit} Analysen",
    "daysLeft": "{days, plural, one {noch # Tag} other {noch # Tage}}",
    "nudgeWeb": "sichern Sie sich jetzt Ihre Lizenz.",
    "nudgeNative": "wir melden uns per E-Mail mit den nächsten Schritten.",
    "blockedTitle": "Demo beendet.",
    "reasonAnalyses": "Ihr Analysen-Budget ist aufgebraucht.",
    "reasonExpired": "Ihr Demo-Zeitraum ist abgelaufen.",
    "reasonSubscription": "Ihre Lizenz ist ausgelaufen.",
    "blockedWeb": "Erwerben Sie eine Lizenz, um ZeroSnag weiter zu nutzen — Ihre bisherigen Analysen bleiben einsehbar.",
    "blockedNative": "Wir haben Ihnen eine E-Mail mit den nächsten Schritten geschickt. Ihre bisherigen Analysen bleiben einsehbar.",
    "cta": "Lizenz erwerben",
    "lapsedTitle": "Zugang pausiert.",
    "lapsedWeb": "Reaktivieren Sie Ihre Lizenz, um weiterzuarbeiten — Ihre Daten bleiben vollständig erhalten.",
    "lapsedNative": "Wir haben Ihnen eine E-Mail mit den nächsten Schritten geschickt. Ihre Daten bleiben vollständig erhalten.",
    "ctaRenew": "Lizenz verlängern"
  },
  "demoIntro": {
    "title": "Willkommen bei ZeroSnag",
    "subtitle": "Ihr Demo-Zugang ist freigeschaltet. Kurz, was Sie erwartet:",
    "includedAnalyses": "{limit, plural, one {# KI-Analyse inklusive} other {# KI-Analysen inklusive}} — jede analysierte Aufnahme zählt einmal.",
    "includedDays": "{days, plural, one {Noch # Tag Testzeitraum} other {Noch # Tage Testzeitraum}} — es zählt, was zuerst aufgebraucht ist.",
    "howToStart": "Foto aufnehmen oder hochladen — die KI erkennt Mängel automatisch und markiert sie im Bild.",
    "whatCounts": "Projekte, Mängel-Tickets und Berichte können Sie unbegrenzt nutzen und exportieren.",
    "afterWeb": "Danach bleibt alles Erfasste einsehbar. Zum Weiterarbeiten buchen Sie eine Lizenz — monatlich oder jährlich mit Rabatt.",
    "afterNative": "Danach bleibt alles Erfasste einsehbar. Wir melden uns rechtzeitig per E-Mail mit den nächsten Schritten.",
    "cta": "Los geht's"
  },
  "board": {
    "title": "Aufgaben",
    "backToProject": "Zurück zum Projekt",
    "viewBoard": "Board",
    "viewList": "Liste",
    "addList": "Liste hinzufügen",
    "newListPlaceholder": "z. B. Haus A",
    "renameList": "Umbenennen",
    "archiveList": "Liste archivieren",
    "listActions": "Listenaktionen",
    "addCard": "Karte hinzufügen",
    "newCardPlaceholder": "Was ist zu tun?",
    "emptyColumn": "Noch keine Karten",
    "emptyTitle": "Noch kein Board",
    "emptyHint": "Listen sind frei benennbar — oft Gebäude, Bauabschnitte oder ein Status.",
    "createFirstList": "Erste Liste anlegen",
    "defaultListName": "Offen",
    "loadingBoard": "Board wird geladen …",
    "cardCount": "{count, plural, =1 {1 Karte} other {# Karten}} insgesamt",
    "cardDetails": "Karte",
    "titleLabel": "Titel",
    "descriptionLabel": "Beschreibung",
    "descriptionPlaceholder": "Details, Ort, was zu tun ist …",
    "dueLabel": "Frist",
    "assigneeLabel": "Zuständig",
    "assigneeNone": "Niemand",
    "groupTeam": "Mitarbeiter",
    "groupContractors": "Nachunternehmer",
    "markDone": "Als erledigt markieren",
    "reopen": "Wieder öffnen",
    "done": "Erledigt",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "close": "Schließen",
    "delete": "Löschen",
    "deleteConfirm": "Wirklich löschen?",
    "dragHandle": "Karte „{title}\" verschieben",
    "toggleDone": "Karte „{title}“ abhaken",
    "allLists": "Alle Listen",
    "allAssignees": "Alle Zuständigen",
    "openOnly": "Nur offene",
    "clearFilter": "Filter zurücksetzen",
    "shown": "{shown} von {total}",
    "noneMatchFilter": "Keine Karte passt zum Filter.",
    "overdue": "überfällig",
    "contractorAccess": "Nachunternehmer-Zugang",
    "contractorAccessHint": "Ein Link zeigt der Firma nur ihre eigenen Karten in diesem Projekt — ohne Konto. Er läuft nach 30 Tagen ab und lässt sich jederzeit zurückziehen.",
    "pickContractor": "Firma wählen",
    "createLink": "Link erstellen",
    "linkCreated": "Link erstellt und in die Zwischenablage kopiert.",
    "linkCreateFailed": "Link konnte nicht erstellt werden.",
    "linkRevoked": "Link zurückgezogen.",
    "linkRevokeFailed": "Widerruf fehlgeschlagen.",
    "linkCopied": "Link kopiert.",
    "copyLink": "Link kopieren",
    "revokeLink": "Link zurückziehen",
    "linkLive": "aktiv",
    "linkExpired": "abgelaufen",
    "linkRevokedBadge": "zurückgezogen",
    "linkExpiresAt": "gültig bis {date}",
    "linkRevokedAt": "zurückgezogen am {date}",
    "noLinksYet": "Noch kein Link vergeben.",
    "noContractorsInProject": "Für dieses Projekt sind noch keine Nachunternehmer hinterlegt.",
    "moveFailed": "Karte konnte nicht verschoben werden.",
    "saveFailed": "Konnte nicht gespeichert werden.",
    "deleteFailed": "Löschen fehlgeschlagen.",
    "loadFailed": "Board konnte nicht geladen werden",
    "loadFailedHint": "Bitte die Seite neu laden. Bleibt es dabei, melde dich bei uns.",
    "retry": "Neu laden",
    "archiveNotEmpty": "{count, plural, =1 {In der Liste liegt noch 1 Karte — bitte zuerst leeren.} other {In der Liste liegen noch # Karten — bitte zuerst leeren.}}",
    "dragList": "Liste „{name}“ verschieben",
    "movedToEnd": "Die Reihenfolge war durcheinander — ans Ende gestellt.",
    "assigneeUnknown": "Zugewiesen (unbekannt)",
    "unknownContractor": "Unbekannte Firma",
    "linkCopyFailed": "Kopieren nicht möglich — Link bitte von Hand markieren.",
    "confirmArchiveList": "Liste „{name}“ wirklich archivieren?",
    "listArchived": "Liste archiviert.",
    "listRestored": "Liste wiederhergestellt.",
    "restoreList": "Wiederherstellen",
    "archivedLists": "{count, plural, =1 {1 archivierte Liste} other {# archivierte Listen}}",
    "archivedCardCount": "{count, plural, =1 {1 Karte darin} other {# Karten darin}}",
    "discardChanges": "Ungespeicherte Änderungen an Titel, Beschreibung oder Frist gehen verloren.",
    "confirmRevoke": "Zugang für „{name}“ wirklich sperren? Der Link wird sofort ungültig; ein neuer Link hat eine andere Adresse.",
    "addCardFailed": "Karte konnte nicht angelegt werden.",
    "addListFailed": "Liste konnte nicht angelegt werden.",
    "renameFailed": "Umbenennen fehlgeschlagen.",
    "archiveFailed": "Archivieren fehlgeschlagen.",
    "restoreFailed": "Wiederherstellen fehlgeschlagen.",
    "discardConfirm": "Verwerfen",
    "keepEditing": "Weiter bearbeiten",
    "archivedListsFailed": "Archivierte Listen konnten nicht geladen werden. Das Board selbst ist davon nicht betroffen.",
    "revokeConfirm": "Wirklich sperren"
  },
  "boardLink": {
    "invalidTitle": "Dieser Link ist nicht mehr gültig",
    "invalidBody": "Er ist abgelaufen oder wurde zurückgezogen. Bitte fordern Sie einen neuen Link bei Ihrem Ansprechpartner an.",
    "errorTitle": "Etwas ist schiefgelaufen",
    "errorBody": "Bitte laden Sie die Seite neu. Bleibt es dabei, melden Sie sich bei Ihrem Ansprechpartner.",
    "openCount": "{count, plural, =0 {Aktuell sind keine Aufgaben offen.} =1 {1 offene Aufgabe} other {# offene Aufgaben}}",
    "doneHeading": "Erledigt",
    "none": "Für Sie sind derzeit keine Aufgaben hinterlegt.",
    "due": "Frist: {date}",
    "overdue": "überfällig",
    "footer": "Bereitgestellt über ZeroSnag",
    "sentBy": "Gesendet von {sender}"
  }
}
